import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c77a5180"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "formPage"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notification bulmaNotification is-warning mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "There are no applications available for you to start")
], -1))
const _hoisted_3 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_4 = {
  key: 2,
  class: "formPage"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Which benefits would you like to apply for?", -1))
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "termsBox" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "termsHeading" }, "You must read and agree to the following declaration to continue", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "termsContent" }, [
  /*#__PURE__*/_createElementVNode("p", null, "In the TANF Program, an IPV (Intentional Program Violation) is an intentional action by an individual to establish or maintain an assistance unit's (AU's) eligibility, or to increase or prevent a decrease in the AU's benefits, by providing false or misleading information or withholding information."),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "mt-3" }, "Any household member who hides information and does not report changes on time or does not tell the truth will lose TANF benefits for six months for the first violation, twelve months for the second violation and permanently for the third violation. The misuse of the cash assistance funds or TANF DEBIT card to withdraw cash or perform transactions at casinos, liquor stores, adult-oriented entertainment facilities “strip clubs”, poker rooms, bail bonds, night clubs/salons/taverns, bingo halls, race tracks, gaming establishments, gun/ammunition stores, cruise ships, psychic readers, smoking shops, tattoo/piercing shops, and spa/massage salons is strictly prohibited and will result in a loss of TANF benefits for six months for the first violation, twelve months for the second violation and permanently for the third violation."),
    /*#__PURE__*/_createElementVNode("li", { class: "mt-3" }, "If a court of law finds you or any household member hiding information or you do not report changes on time or do not tell the truth and are convicted, you may not get TANF for 6 months for the first violation, 12 months for the second violation and permanently for the third violation."),
    /*#__PURE__*/_createElementVNode("li", { class: "mt-3" }, "If a court of law finds you or any household member guilty of giving false information about where you live so you can receive benefits in more than one state, you will be barred for 10 years."),
    /*#__PURE__*/_createElementVNode("li", { class: "mt-3" }, "If a court convicted you of a drug-related charge controlled substance or a serious violent felony, on or after 1/1/97 you or that household member will not be eligible and/or permanently disqualified.")
  ])
], -1))
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "termsBox" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "termsHeading" }, "You must read and agree to the following declaration to continue", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "termsContent" }, [
  /*#__PURE__*/_createElementVNode("p", null, "I declare under penalty of perjury to the best of my knowledge and belief that the person(s) for whom I am applying for benefits is/are U.S. citizen(s) or are noncitizen(s) lawfully present in the United States. I further certify that all of the information provided on this application is true and correct to the best of my knowledge."),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "I understand and agree that DHS-DFCS, DCH and authorized Federal Agencies may verify the information I give on this application. Information may be obtained from past or present employers. I understand that my information will be used to track wage information and my participation in work activities."),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "I will report any change in my situation according to Food Stamp/Medicaid and/or TANF program requirements. I will also report If anyone in my household receives lottery or gambling winnings, gross amount of $3500 or more (before taxes or other amounts are withheld). I will report these winnings within 10 days from the end of the month in which my household receives the winnings."),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "I understand if any information is incorrect, my benefits may be reduced or denied, and I may be subject to criminal prosecution or disqualified from DHS-DFCS programs for knowingly providing incorrect information. I understand that I can be prosecuted if I provide false information or hide information."),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, "I understand that if I fail to tell DHS-DFCS about some of my expenses at my application or renewal interview and/or fail to verify them that DHS-DFCS will not budget that expense in calculating the amount of my food stamp benefits.")
], -1))
const _hoisted_17 = { key: 4 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Do you have somebody who will act as your authorized representative?", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "They will need to be with you to sign this application.", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "They will be allowed to help you fill out your application, or complete eligibility interviews on your behalf.", -1))
const _hoisted_21 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_22 = { key: 5 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Do you have another authorized representative?", -1))
const _hoisted_24 = { key: 6 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "About your representatives", -1))
const _hoisted_26 = { key: 7 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some basic information about yourself", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"-0.5em","margin-bottom":"1.5em"} }, [
  /*#__PURE__*/_createElementVNode("em", null, "Not being a US citizen does not disqualify you from benefits")
], -1))
const _hoisted_29 = {
  class: "column",
  style: {"padding-top":"2.75rem"}
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" You are ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" old ")
const _hoisted_33 = { key: 8 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide your address", -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 9 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please let us know how the benefits office can reach you", -1))
const _hoisted_38 = { key: 10 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Do you require any additional assistance?", -1))
const _hoisted_40 = { key: 11 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please tell us about all members of your household", -1))
const _hoisted_42 = {
  class: "column",
  style: {"padding-top":"2rem"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" This household member is ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" old ")
const _hoisted_46 = {
  key: 2,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_47 = {
  key: 3,
  class: "mt-6"
}
const _hoisted_48 = { key: 12 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "These questions will help speed up your Food Stamps application", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_57 = { key: 13 }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please answer these additional questions about yourself and your household members. Your answers may affect the benefits you are eligible for", -1))
const _hoisted_59 = { key: 1 }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_65 = { key: 2 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_71 = { key: 4 }
const _hoisted_72 = { key: 3 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_74 = { key: 4 }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_76 = { key: 5 }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_78 = { key: 14 }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please tell us about your household income", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Please add information for "),
  /*#__PURE__*/_createElementVNode("strong", null, "ALL"),
  /*#__PURE__*/_createTextVNode(" household income.")
], -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This includes wages, tips, bonuses, self-employment, pensions, child support, disability, etc.", -1))
const _hoisted_82 = {
  key: 0,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_83 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_84 = { key: 15 }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Do you pay for the care of any dependent child or disabled adult household members?", -1))
const _hoisted_86 = { key: 0 }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Please list these all of these expenses", -1))
const _hoisted_88 = {
  key: 0,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_89 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_90 = { key: 16 }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Do you pay transport expenses for a dependent child or disabled adult household member?", -1))
const _hoisted_92 = { key: 0 }
const _hoisted_93 = { key: 17 }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Does anyone in your household who is 60+ years of age, or is disabled, have any medical expenses?", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "This DOES NOT include transport expenses.")
], -1))
const _hoisted_96 = { key: 0 }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Please list these all of these expenses", -1))
const _hoisted_98 = {
  key: 0,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_99 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_100 = { key: 18 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Does anyone in your household who is 60+ years of age, or is disabled, have any medical transportation expenses?", -1))
const _hoisted_102 = { key: 0 }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Please list these all of these expenses", -1))
const _hoisted_104 = {
  key: 0,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_105 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_106 = { key: 19 }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Does anyone in your household pay child support to someone living OUTSIDE of the home?", -1))
const _hoisted_108 = { key: 0 }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Please list these all of these expenses", -1))
const _hoisted_110 = {
  key: 0,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_111 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_112 = { key: 20 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageSubHeading" }, "Does anyone in your household pay for any shelter or home utility expenses?", -1))
const _hoisted_114 = { key: 0 }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "questionDivider" }, null, -1))
const _hoisted_123 = { key: 21 }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Do you share monthly household expenses with anyone in the home?", -1))
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 22 }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Does someone else pay any of these household bills for you?", -1))
const _hoisted_128 = { key: 0 }
const _hoisted_129 = { key: 23 }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please upload photos / scans of any existing ID documents, and evidence of income and expenses, which you have available", -1))
const _hoisted_131 = { key: 24 }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please upload photos / scans of any existing ID documents, or evidence of income and expenses, which you have available", -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Front Image *", -1))
const _hoisted_134 = { class: "mt-5" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Back Image (optional)", -1))
const _hoisted_136 = {
  key: 0,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_137 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_138 = { key: 25 }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please let us know if you agree to us verifying your identity", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Do we have your permission to verify your identity with Equifax?", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This will require us to share some of your information with them.", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Verifying your identity may allow us to speed up your application, and improve the chance of a successful result.")
], -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "However, you may opt-out if you'd prefer.", -1))
const _hoisted_146 = { key: 26 }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please let us know how we should keep you up-to-date about your application", -1))
const _hoisted_148 = {
  key: 2,
  class: "notification bulmaNotification is-warning mt-4"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "If you don't provide any contact information, you will need to speak to your caseworker for updates on your application", -1))
const _hoisted_150 = [
  _hoisted_149
]
const _hoisted_151 = { key: 27 }
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "We're almost done!", -1))
const _hoisted_153 = { key: 0 }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Please ask for somebody to assist you and act as a witness.", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "They can help you to sign above with an 'X'.", -1))
const _hoisted_156 = { key: 28 }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "pageHeading",
  style: {"text-align":"center"}
}, "Ok! We're ready to submit your application", -1))
const _hoisted_158 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_159 = { key: 29 }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Congratulations! Your application has been submitted", -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "You can return to the home page to view your applications.", -1))
const _hoisted_162 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_163 = {
  key: 30,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_164 = {
  key: 31,
  class: "is-flex is-flex-direction-row mt-6"
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))

import { 
    moduleState, initNewApplication, submitModule,
    sections, type Page, type SupportDocument,
    EquifaxConsentOptions
} from './module';

import { Core, Feature, GeorgiaDfcsBenefits, ProfileTypes } from '@minicity/core';
import { isModuleEnabled, sessionState } from '@/core/session';
import { uploadFile } from '@/core/api';

import LoadingSpinner from '@/components/LoadingSpinner.vue';
import LoadingPage from '@/components/LoadingPage.vue';
import RequiredAssistanceEditor from './components/RequiredAssistanceEditor.vue';
import ShelterOrUtilityExpenseEditor from './components/ShelterOrUtilityExpenseEditor.vue';
import AuthorizedRepresentativeEditor from './components/AuthorizedRepresentativeEditor.vue';

import { useForm, Form, PageSpecs } from '@/composables/useForm';
import { Validations } from '@/composables/useValidation';

import ListEditor from '@/components/ListEditor.vue';
import { useEditableList } from '@/composables/useEditableList';

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { createDraftApplication, getDraftApplication, updateDraftApplicationContent } from '../api';
import { DeepPartial, formatAge, formatName, mapHttpError, notifyError } from '@/core/utils';
import { notifyNetworkError } from '@/core/utils';
import { getApplicationStatus } from '@/features/applicationStatus/api';

import { InteractionType, logFeatureInteraction } from '@/features/analytics/api';
import FormSelectField from '@/components/FormSelectField.vue';
import SignaturePadField from "@/components/SignaturePadField.vue";
import SupportDocPhotoGuidance from "../components/SupportDocPhotoGuidance.vue";


type QuestionSpec<Answers> = {name: string, trigger: keyof Answers, followUps: (keyof Answers)[]};

export default /*#__PURE__*/_defineComponent({
  __name: 'GeorgiaDfcsBenefitsApplicationForm',
  setup(__props) {

const draftId = ref<string|null>(null);

/*
 * Define any special logic for each page
 */
 function validateAnswers<Answers>(answers: Answers, questionSpecs: QuestionSpec<Answers>[]) {
    for (const spec of questionSpecs) {
        const triggerAnswer = answers[spec.trigger];
        if (triggerAnswer === false || triggerAnswer === 0 || triggerAnswer === "0") {
            for (const followUpKey of spec.followUps) {
                (answers as any)[followUpKey] = undefined;
            }
        } else if (triggerAnswer) {
            for (const followUpKey of spec.followUps) {
                const answer = answers[followUpKey];
                if (answer === undefined || answer === null || answer === "") return [`Please answer all parts for question '${spec.name}'`];
            }
        } else return [`Please answer question '${spec.name}'`];
    }
}

const pages: PageSpecs<Page> = {
    "introVideo": {
        nextPage: "selectBenefitTypes"
    },
    "selectBenefitTypes": {
        validate: ()=>{
            const selectedBenefits = moduleState.value!.application!.selectedBenefits!;

            if (!selectedBenefits.foodStamps && !selectedBenefits.TANF && !selectedBenefits.refugeeCashAssistance && !selectedBenefits.medicaid) {
                return ["Please select at least one benefit"];
            }

            if (selectedBenefits.foodStamps) {
                moduleState.value!.application!.expeditedFoodStampQualification ||= {};
            }
        },
        nextPage: "tanfWaiver",
    },
    "tanfWaiver": {
        enabled: ()=>moduleState.value!.application!.selectedBenefits!.TANF!,
        validate: ()=>{
            if (!moduleState.value!.miscState.tanfWaiver.confirmed) return ["You cannot apply for benefits unless you read and agree to these terms"];
        },
        nextPage: "generalWaiver"
    },
    "generalWaiver": {
        validate: ()=>{
            if (!moduleState.value!.miscState.generalWaiver.confirmed) return ["You cannot apply for benefits unless you read and agree to these terms"];
        },
        nextPage: "authorizedRepresentative"
    },
    "authorizedRepresentative": {
        validate: ()=>{
            if (moduleState.value!.application!.authorizedRepresentatives!.first === null) {
                delete moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.FIRST_REPRESENTATIVE];
                delete moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.SECOND_REPRESENTATIVE];
                moduleState.value!.application!.authorizedRepresentatives = {};
            } else if (moduleState.value!.application!.authorizedRepresentatives!.first === undefined) {
                return (authorizedRep1Field.value as any).getValidationErrors();
            } else {
                const sigData = (authorizedRep1Field.value as any).getSignatureData();
                if (!sigData) return ["Your representative must sign their name"];
                moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.FIRST_REPRESENTATIVE] = sigData;
            }
        },
        nextPage: "authorizedRepresentative2"
    },
    "authorizedRepresentative2": {
        validate: ()=>{
            if (moduleState.value!.application!.authorizedRepresentatives!.second === null) {
                delete moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.SECOND_REPRESENTATIVE];
            } else if (moduleState.value!.application!.authorizedRepresentatives!.second === undefined) {
                return (authorizedRep2Field.value as any).getValidationErrors();
            } else {
                const sigData = (authorizedRep2Field.value as any).getSignatureData();
                if (!sigData) return ["Your representative must sign their name"];
                moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.SECOND_REPRESENTATIVE] = sigData;
            }
        },
        enabled: ()=>Boolean(moduleState.value!.application!.authorizedRepresentatives!.first),
        nextPage: "authorizedRepresentativeSettings"
    },
    "authorizedRepresentativeSettings": {
        enabled: ()=>Boolean(moduleState.value!.application!.authorizedRepresentatives!.first),
        validate: ()=>{
            if (moduleState.value!.application!.authorizedRepresentatives!.toReceiveMedicaidCard == undefined) {
                return ["Please indicate whether your representative(s) require Medicaid cards"];
            }
        },
        nextPage: "basicCitizenInfo"
    },
    "basicCitizenInfo": {
        validate: ()=>{
            const applicant = moduleState.value!.application!.applicant!;
            if (applicant.firstName!.length == 0) return ["Please enter your first name"];
            if (applicant.lastName!.length == 0) return ["Please enter your last name"];
            if (applicant.socialSecurityNumber!.length != 9) return ["Social Security Number should be in the form AAABBCCCC"];
            if (applicant.isUSCitizenOrQualifiedImmigrant == undefined) return ["Please indicate your citizenship / immigration status"];
            if (!applicant.sex) return ["Please select your sex / gender"];
            if (!applicant.dateOfBirth) return ["Please enter your date of birth"];
        },
        nextPage: "address"
    },
    "address": {
        enabled: () => false, // disabled - always using PO box
        onLoad: () => {
            const applicant = moduleState.value!.application!.applicant!;
            if (!applicant.mailingAddress) {
                applicant.mailingAddress = {
                    number: "",
                    street: "",
                    city: "",
                    state: undefined,
                    postalCode: ""
                };
            }
        },
        validate: ()=>{
            const applicant = moduleState.value!.application!.applicant!;
            
            if (applicant.useCareProviderAddressForMailing) {
                applicant.mailingAddress = undefined;
                applicant.streetAddress = undefined;
            } else {
                if (applicant.mailingAddress!.number!.length == 0) return ["Please enter your house / building number"];
                if (applicant.mailingAddress!.street!.length == 0) return ["Please enter your street name"];
                if (applicant.mailingAddress!.city!.length == 0) return ["Please enter your city"];
                if (applicant.mailingAddress!.postalCode!.length == 0) return ["Please enter your zip code"];
                if (!applicant.mailingAddress!.state) return ["Please select your state"];
            }

            // Copy these across for street address
            applicant.useCareProviderAddressForStreet = applicant.useCareProviderAddressForMailing;
            applicant.streetAddress = applicant.mailingAddress;
        },
        nextPage: "contactInfo"
    },
    "contactInfo": {
        validate: ()=>{
            const applicant = moduleState.value!.application!.applicant!;
            if (applicant.smsCommunicationPreferred) {
                if (applicant.mainPhone!.length == 0) return ["Please enter your phone number"];
            } else {
                applicant.mainPhone = undefined;
            }

            if (applicant.emailCommunicationPreferred) {
                if (!Validations.email(applicant.email)) return ["Please enter a valid email address"];
            } else {
                applicant.email = undefined;
            }
        },
        nextPage: "communicationPreferences"
    },
    "communicationPreferences": {
        validate: ()=>{
            const applicant = moduleState.value!.application!.applicant!;

            if (applicant.preferredLanguage?.length == 0) return ["Please indicate your preferred language"];
        },
        nextPage: "householdMembers"
    },
    "householdMembers": {
        nextPage: "foodStampsQualificationQuestions"
    },
    "foodStampsQualificationQuestions": {
        enabled: ()=>moduleState.value!.application!.selectedBenefits!.foodStamps!,
        validate: ()=>{
            const qs = moduleState.value!.application!.expeditedFoodStampQualification!;

            const questionSpecs:QuestionSpec<typeof qs>[] = [
                {name: "Are you, or any household members, migrant or seasonal farm workers?", trigger: "isMigrantOrSeasonalFarmWorker", followUps: ["whoMigrantOrSeasonalFarmWorker"]},
                {name: "Have you received energy assistance in the last 12 months?", trigger: "hasReceivedEnergyAssistance", followUps: ["energyAssistanceAmount"]},
                {name: "What is your total earned income expected for this month?", trigger: "totalEarnedIncomeThisMonth", followUps: ["employerName", "employmentHoursPerWeek", "employmentBeginDate", "employmentEndDate", "employmentPayRate", "earnedIncomeFrequency"]},
                {name: "What is your total unearned income expected for this month", trigger: "totalUnearnedIncomeThisMonth", followUps: ["firstUnearnedIncomeType", "firstUnearnedIncomeAmount", "firstUnearnedIncomeFrequency"]},
                {name: "What is your total earned and unearned income expected for this month?", trigger: "totalIncomeThisMonth", followUps: []},
                {name: "How much money do you and all household members have in cash or in the bank?", trigger: "totalMoneyInCashAndBank", followUps: []},
                {name: "What is the monthly total you pay for rent, mortgage, property taxes, and/or homeowners insurance?", trigger: "totalRentOrMortgagePayment", followUps: []},
                {name: "What is the monthly total you pay for electric, water, gas, and/or other utilities?", trigger: "totalUtilitiesPayment", followUps: []},
                {name: "Have you received energy assistance in the last 12 months?", trigger: "hasReceivedEnergyAssistance", followUps: ["energyAssistanceAmount"]},
            ];

            if (qs.totalUnearnedIncomeThisMonth != 0 && moduleState.value!.miscState.foodStampsQualificationQuestions.hasSecondUnearnedIncome) {
                questionSpecs.push(
                    {name: "I have another source of unearned income", trigger: "totalUnearnedIncomeThisMonth", followUps: ["secondUnearnedIncomeType", "secondUnearnedIncomeAmount", "secondUnearnedIncomeFrequency"]}
                );
            } else {
                for (const q of ["secondUnearnedIncomeType", "secondUnearnedIncomeAmount", "secondUnearnedIncomeFrequency"]) {
                    (qs as any)[q] = undefined;
                }
            }

            return validateAnswers(qs, questionSpecs);
        },
        nextPage: "additionalQualificationQuestions"
    },
    "additionalQualificationQuestions": {
        validate: ()=>{
            const qs = moduleState.value!.application!.additionalQualifications!;
            const selectedBenefits = moduleState.value!.application!.selectedBenefits!;

            const questionSpecs:QuestionSpec<typeof qs>[] = [
                {name: "Has anyone received any benefits in another county or state?", trigger: "hasBenefitsFromOtherCountyOrState", followUps: ["whoBenefitsFromOtherCountyOrState", "whereBenefitsFromOtherCountyOrState", "whenBenefitsFromOtherCountyOrState"]},
            ];

            if (selectedBenefits.foodStamps) {
                questionSpecs.push(
                    {name: "Has anyone been convicted of giving false information about where they live or who they are to get multiple Food Stamps benefits in more than one area after 8/22/96?", trigger: "hasFalseInformationBenefitsConvicion", followUps: ["whoFalseInformationBenefitsConvicion", "whereFalseInformationBenefitsConvicion", "whenFalseInformationBenefitsConvicion"]},
                    {name: "Has anyone been convicted of trading Food Stamp benefits for drugs after 8/22/96?", trigger: "hasFoodStampDrugTradingConviction", followUps: ["whoFoodStampDrugTradingConviction", "whenFoodStampDrugTradingConviction"]},
                    {name: "Has anyone been convicted of buying or selling Food Stamp benefits over $500 after 8/22/96?", trigger: "hasFoodStampSellingConviction", followUps: ["whoFoodStampSellingConviction", "whenFoodStampSellingConviction"]},
                    {name: "Have you or any household member been convicted of trading Food Stamp benefits for guns, ammunition or explosives after 8/22/96?", trigger: "hasFoodStampWeaponsTradingConviction", followUps: ["whoFoodStampWeaponsTradingConviction", "whenFoodStampWeaponsTradingConviction"]},
                    {name: "Has anyone received lottery or gambling winnings?", trigger: "hasGamblingWinnings", followUps: ["whoGamblingWinnings", "whenGamblingWinnings", "gamblingWinningsAmount"]},
                );
            }

            if (selectedBenefits.foodStamps || selectedBenefits.TANF) {
                questionSpecs.push(
                    {name: "Did anyone in your household voluntarily quit a job, or voluntarily reduce their work hours below 30 hours per week, within the last 30 days?", trigger: "hasVoluntarilyQuitOrReducedHours", followUps: ["whoVoluntarilyQuitOrReducedHours", "whyVoluntarilyQuitOrReducedHours"]},
                    {name: "Is anyone disqualified from the Food Stamp or TANF Program?", trigger: "hasFoodStampOrTANFDisqualification", followUps: ["whoFoodStampOrTANFDisqualification", "whereFoodStampOrTANFDisqualification"]},
                    {name: "Is anyone trying to avoid prosecution or jail for a felony?", trigger: "isAvoidingProsecutionOrJail", followUps: ["whoAvoidingProsecutionOrJail"]},
                    {name: "Is anyone violating conditions of probation or parole?", trigger: "hasParoleViolation", followUps: ["whoParoleVoliation"]},
                    {name: "Does anyone have a violent or drug-related felony conviction after 8/22/96?", trigger: "hasFelonyDrugOrViolenceConviction", followUps: ["whoFelonyDrugOrViolenceConviction", "whenFelonyDrugOrViolenceConviction", "isComplyingWithFelonyDrugOrViolenceConvictionProbationTerms", "isComplyingWithFelonyDrugOrViolenceConvictionParoleTerms", "hasCompletedAllFelonyDrugOrViolenceConvictionTerms"]},
                );
            }

            if (selectedBenefits.medicaid) {
                questionSpecs.push(
                    {name: "Does anyone have any unpaid medical bills for the last 3 months?", trigger: "hasUnpaidMedicalBills", followUps: []},
                );
            }

            if (selectedBenefits.medicaid || selectedBenefits.TANF) {
                questionSpecs.push(
                    {name: "Is anyone pregnant?", trigger: "isPregnant", followUps: ["whoPregnant", "pregnancyDueDate"]},
                );
            }

            if (selectedBenefits.TANF) {
                questionSpecs.push(
                    {name: "Has anyone used TANF funds or the EPPIC Card at liquor stores, casinos, poker rooms, adult entertainment business, bail bonds, night clubs, salons/taverns, bingo halls, race tracks, gun/ammunition stores, cruise ships, psychic readers, smoking shops, tattoo/piercing shops or spa/massage salons?", trigger: "hasMisusedTANF", followUps: ["whoMisusedTANF", "whenMisusedTANF"]},
                );
            }

            return validateAnswers(qs, questionSpecs);
        },
        nextPage: "income"
    },
    "income": {
        nextPage: "careExpenses"
    },
    "careExpenses": {
        validate: () => {
            if (moduleState.value!.miscState.expenses.hasCareExpenses == undefined) return ["Please indicate whether there are care expenses"];
            else if (!moduleState.value!.miscState.expenses.hasCareExpenses) {
                moduleState.value!.application.expenses!.careExpenses = [];
            }
        },
        nextPage: "dependentTransportationExpenses"
    },
    "dependentTransportationExpenses": {
        validate: () => {
            const expenses = moduleState.value!.application!.expenses!;
            if (expenses.hasDependentTransportationExpenses == undefined) return ["Please indicate whether you pay transport expenses for a dependent"];
            
            if (expenses.hasDependentTransportationExpenses) {
                if (moduleState.value!.miscState.expenses.hasCareExpenses) {
                    if (expenses.areDependentTransportationExpensesIncluded == undefined) return ["Please indicate whether you have included these expenses on the previous screen"];

                    if (expenses.areDependentTransportationExpensesIncluded) {
                        expenses.totalMilesDrivenWeekly = undefined;
                    } else {
                        if (!expenses.totalMilesDrivenWeekly) return ["Please indicate the total number of miles driven weekly"];
                    }
                } else {
                    expenses.areDependentTransportationExpensesIncluded = false;
                    if (!expenses.totalMilesDrivenWeekly) return ["Please indicate the total number of miles driven weekly"];
                }
            } else {
                expenses.areDependentTransportationExpensesIncluded = undefined;
                expenses.totalMilesDrivenWeekly = undefined
            }
        },
        nextPage: "medicalExpenses"
    },
    "medicalExpenses": {
        validate: () => {
            if (moduleState.value!.miscState.expenses.hasMedicalExpenses == undefined) return ["Please indicate whether there are medical expenses"];
            else if (!moduleState.value!.miscState.expenses.hasMedicalExpenses) {
                moduleState.value!.application.expenses!.medicalExpenses = [];
            }
        },
        nextPage: "medicalTransportationExpenses"
    },
    "medicalTransportationExpenses": {
        validate: () => {
            if (moduleState.value!.miscState.expenses.hasMedicalTransportationExpenses == undefined) return ["Please indicate whether there are medical transportation expenses"];
            else if (!moduleState.value!.miscState.expenses.hasMedicalTransportationExpenses) {
                moduleState.value!.application.expenses!.medicalTransportationExpenses = [];                
            }
        },
        nextPage: "childSupportExpenses"
    },
    "childSupportExpenses": {
        validate: () => {
            if (moduleState.value!.miscState.expenses.hasChildSupportExpenses == undefined) return ["Please indicate whether there are child support expenses"];
            else if (!moduleState.value!.miscState.expenses.hasChildSupportExpenses) {
                moduleState.value!.application.expenses!.childSupportExpenses = [];                
            }
        },
        nextPage: "shelterOrUtilityExpenses"
    },
    "shelterOrUtilityExpenses": {
        onLoad() {
            if (!moduleState.value!.application!.expenses!.shelterOrUtilityExpenses) {
                moduleState.value!.application!.expenses!.shelterOrUtilityExpenses = {};
            }
        },
        validate() {
            if (moduleState.value!.miscState.expenses.hasShelterOrUtilityExpenses == undefined) return ["Please indicate whether there are shelter or utility expenses"];
            else if (!moduleState.value!.miscState.expenses.hasShelterOrUtilityExpenses) {
                moduleState.value!.application!.expenses!.shelterOrUtilityExpenses = undefined;
                moduleState.value!.application!.expenses!.sharedExpenses = undefined;
                moduleState.value!.application!.expenses!.otherBillPayer = undefined;
            } else {
                const expenses = moduleState.value!.application!.expenses!.shelterOrUtilityExpenses!;
                if (expenses.rentOrMortgage === undefined) return ["Please provide information about your rent / mortgage payments"];
                if (expenses.propertyTax === undefined) return ["Please provide information about your property tax payments"];
                if (expenses.propertyInsurance === undefined) return ["Please provide information about your property insurance payments"];
                if (expenses.electricity === undefined) return ["Please provide information about your electricity payments"];
                if (expenses.gas === undefined) return ["Please provide information about your gas payments"];
                if (expenses.garbage === undefined) return ["Please provide information about your garbage disposal payments"];
                if (expenses.telephone === undefined) return ["Please provide information about your telephone payments"];
                if (expenses.other === undefined) return ["Please provide information about any other shelter or utility payments"];
            }
        },
        nextPage: "sharedExpenses"
    },
    "sharedExpenses": {
        enabled: ()=>moduleState.value!.miscState.expenses.hasShelterOrUtilityExpenses,
        onLoad() {
            if (!moduleState.value!.application!.expenses!.sharedExpenses) {
                moduleState.value!.application!.expenses!.sharedExpenses = {
                    landlordAddress: {number: "", street: "", city: "", state: undefined, postalCode: ""}
                };
            }
        },
        validate()
         {
            if (moduleState.value!.miscState!.expenses!.hasSharedExpenses == undefined) return ["Please indicate whether there are shared expenses"];
            else if (!moduleState.value!.miscState.expenses.hasSharedExpenses) {
                moduleState.value!.application!.expenses!.sharedExpenses = undefined;
            } else {
                const sharedExpenses = moduleState.value!.application!.expenses!.sharedExpenses!;
                if (sharedExpenses.who?.length == 0) return ["Please indicate who you share expenses with"];
                if (sharedExpenses.comments?.length == 0) return ["Please describe the arrangement"];
                if (sharedExpenses.recipientName?.length == 0) return ["Please indicate who you pay to"];
                if (!sharedExpenses.paymentAmount) return ["Please indicate the amount paid"];
                if (!sharedExpenses.paymentFrequency) return ["Please indicate the payment frequency"];
                if (sharedExpenses.landlordName?.length == 0) return ["Please indicate the landlord's name"];
            }
        },
        nextPage: "otherBillPayer"
    },
    "otherBillPayer": {
        enabled: ()=>moduleState.value!.miscState.expenses.hasShelterOrUtilityExpenses,
        onLoad() {
            if (!moduleState.value!.application!.expenses!.otherBillPayer) {
                moduleState.value!.application!.expenses!.otherBillPayer = {};
            }
        },
        validate() {
            if (moduleState.value!.miscState!.expenses!.hasOtherBillPayer == undefined) return ["Please indicate whether there is another bill payer"];
            else if (!moduleState.value!.miscState.expenses.hasOtherBillPayer) {
                moduleState.value!.application!.expenses!.otherBillPayer = undefined;
            } else {
                const otherBillPayer = moduleState.value!.application!.expenses!.otherBillPayer!;
                if (otherBillPayer.payerName?.length == 0) return ["Please indicate the bill payer's name"];
                if (otherBillPayer.whichBills?.length == 0) return ["Please indicate which bills are paid"];
                if (otherBillPayer.amount?.length == 0) return ["Please indicate the amount paid"];
                if (otherBillPayer.recipientName?.length == 0) return ["Please indicate the person to whom the bills are paid"];
            }
        },
        nextPage: "supportDocGuidance"
    },
    "supportDocGuidance": {
        nextPage: "supportDocUpload"
    },
    "supportDocUpload": {
        nextPage: "equifaxConsent"
    },
    "equifaxConsent": {
        enabled: ()=>isModuleEnabled(Feature.Type.EQUIFAX_CHECKS),
        validate: ()=>{
            const appl = moduleState.value!.application!;
            if (appl.equifaxConsent === undefined) return ["Please indicate whether you agree to us verifying your identity"];
        },
        nextPage: "notificationPreferences"
    },
    "notificationPreferences": {
        validate: ()=>{
            const prefs = moduleState.value!.notificationPreferences!;
            const pageState = moduleState.value!.miscState.notificationPreferences;

            if (pageState.noneEnabled) {
                prefs.email = undefined;
                prefs.sms = undefined;
            } else {
                if (!pageState.emailEnabled && !pageState.smsEnabled) return ["Please indicate how you would like to receive updates about your application"];

                if (pageState.emailEnabled) {
                    if (!Validations.email(prefs.email)) return ["Please enter a valid email address"];
                } else {
                    prefs.email = undefined;
                }

                if (pageState.smsEnabled) {
                    if (!Validations.phone_US(prefs.sms)) return ["Please enter a valid US phone number"];
                } else {
                    prefs.sms = undefined;
                }
            }
        },
        nextPage: "signature"
    },
    "signature": {
        validate: ()=>{
            const sigData = (applicantSignaturePad.value as any).getSignatureData();
            if (!sigData) return ["You must sign your name"];
            moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.CITIZEN] = sigData;

            if (moduleState.value!.miscState.signature.witnessRequired) {
                const sigData = (witnessSignaturePad.value as any).getSignatureData();
                if (!sigData) return ["Your witness must sign their name"];
                moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.WITNESS] = sigData;
            } else {
                delete moduleState.value!.signatures[GeorgiaDfcsBenefits.SignatureType.WITNESS];
            }
        },
        nextPage: "preSubmit"
    },
    "preSubmit": {},
    "completed": {disallowBack: true},
};


/*
 * Initialize
 */
let availableApplicationTypes: string[] = [];

 onMounted(() => {
    if (!sessionState.session) return;
    
    getApplicationStatus(sessionState.session.user.id)
    .then(applStatus => {
        // Determine which application types are available
        // The module must be enabled for the citizen's care provider, and they must not already have an application in-progress
        if (isModuleEnabled('BIRTH_RECORDS') && !applStatus.applications.find(appl => appl.applicationType == 'birthRecords')) {
            availableApplicationTypes.push('birthRecords');
        }

        if (isModuleEnabled('SOCIAL_SECURITY') && !applStatus.applications.find(appl => appl.applicationType == 'socialSecurity')) {
            availableApplicationTypes.push('socialSecurity');
        }
        
        // Load or start a new application
        getDraftApplication(sessionState.session!.user.id, "georgiaDfcsBenefits")
        .then(draft => {
            console.log(`Resumed draft application ${draft.id}`, draft);

            moduleState.value = JSON.parse(draft.content);
            draftId.value = draft.id;
            initFormNavigation();
        })
        .catch(err => {
            console.error("Failed to resume application", err);
            startNewApplication();
        });
    });
});

const startNewApplication = () => {
    console.log("Starting new application");

    moduleState.value = initNewApplication({
        // Initial misc state
        notificationPreferences: {
            emailEnabled: sessionState.session!.user.preferences.notifications.email != undefined,
            smsEnabled: sessionState.session!.user.preferences.notifications.sms != undefined,
            noneEnabled: false,
        },
        foodStampsQualificationQuestions: {
            hasSecondUnearnedIncome: false
        },
        tanfWaiver: {confirmed: false},
        generalWaiver: {confirmed: false},
        expenses: {},
        signature: {witnessRequired: false},
    });

    createDraftApplication(sessionState.session!.user.id, "georgiaDfcsBenefits", moduleState.value)
    .then(createdDraftId => {
        draftId.value = createdDraftId;
        initFormNavigation();
    })
    .catch(err => notifyError(err))
}

let formUpdateTimer: NodeJS.Timeout|null = null; 

const initFormNavigation = () => {
    form.value = useForm(pages, sections, moduleState.value!.formNavState, onFormChanged);

    // Set a timer to regularly push updated form state to server (also keeps session alive)
    const updateTimer = () => {
        console.log("Update timer triggered");
        onFormChanged();
        formUpdateTimer = setTimeout(updateTimer, 30000);
    };
    formUpdateTimer = setTimeout(updateTimer, 30000);

    // Generate analytics event
    logFeatureInteraction("applications/georgiaDfcsBenefits", "GEORGIA_DFCS_BENEFITS", InteractionType.CLICK, JSON.stringify({'draftId': draftId.value, 'page': form.value!.state.activePage, 'errors': form.value!.state.errors}));
}

onUnmounted(() => {
    if (formUpdateTimer) {
        console.log("Diabled update timer", formUpdateTimer);
        clearTimeout(formUpdateTimer);
    }
});

/*
 * Form state
 */
const form = ref<Form<Page>|null>(null);

const currentSection = computed(() => {
    if (!moduleState.value) return null;
    return form.value!.determineCurrentSection();
});

// Element / component references
const authorizedRep1Field = ref(null);
const authorizedRep2Field = ref(null);
const applicantSignaturePad = ref(null);
const witnessSignaturePad = ref(null);

/*
 * Draft saving / form submission
 */
let lastPushedModuleStateJson = "";
const onFormChanged = () => {
    const moduleStateJson = JSON.stringify(moduleState.value);
    if (moduleStateJson == lastPushedModuleStateJson) return; // No change - no need to update

    console.log("Pushing updated form state to server", moduleState.value);

    updateDraftApplicationContent(sessionState.session!.user.id, draftId.value!, moduleState.value)
    .then(() => lastPushedModuleStateJson = moduleStateJson);

    // Generate analytics event
    logFeatureInteraction("applications/georgiaDfcsBenefits", "GEORGIA_DFCS_BENEFITS", InteractionType.PROGRESS, JSON.stringify({'draftId': draftId.value, 'page': form.value!.state.activePage, 'errors': form.value!.state.errors}));
};

const submissionInProgress = ref<boolean>(false);

const submitApplication = async () => {
    form.value!.state.errors = [];
    console.log("Submitting", moduleState.value!.application);

    submissionInProgress.value = true;
    try {
        await submitModule(draftId.value!);
        form.value!.displayPage("completed");

        // Generate analytics event
        logFeatureInteraction("applications/georgiaDfcsBenefits/submit", "GEORGIA_DFCS_BENEFITS", InteractionType.COMPLETION, JSON.stringify({'draftId': draftId.value, 'page': form.value!.state.activePage}));
    } catch (ex) {
        console.log(ex);
        form.value!.state.errors = [`Failed to submit - ${mapHttpError(ex)}`];

        // Generate analytics event
        logFeatureInteraction("applications/georgiaDfcsBenefits/submit", "GEORGIA_DFCS_BENEFITS", InteractionType.ERROR, JSON.stringify({'draftId': draftId.value, 'errors': form.value!.state.errors}));
    } finally {
        submissionInProgress.value = false;
    }
};

/*
 * List editors
 */
 const householdMembers = ref(useEditableList<GeorgiaDfcsBenefits.HouseholdMember>(
    () => moduleState.value!.application.householdMembers! as DeepPartial<GeorgiaDfcsBenefits.HouseholdMember>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<GeorgiaDfcsBenefits.HouseholdMember>) => {
        if (item.firstName!.length == 0) return ["Please enter first name"];
        if (item.lastName!.length == 0) return ["Please enter last name"];
        if (!item.dateOfBirth) return ["Please enter date of birth"];
        if (!item.relationship) return ["Please select this person's relationship to you"];
        if (!item.sex) return ["Please select sex / gender"];
        if (!item.race) return ["Please select race / ethnicity"];

        if (item.isApplyingForBenefits == undefined) return ["Please indicate whether this person is applying for benefits"];

        if (item.isApplyingForBenefits) {
            if (item.socialSecurityNumber!.length != 9) return ["Social Security Number should be in the form AAABBCCCC"];
            if (item.isUSCitizenOrQualifiedImmigrant == undefined) return ["Please indicate citizenship / immigration status"];
        } else {
            item.socialSecurityNumber = undefined;
            item.isUSCitizenOrQualifiedImmigrant = undefined;
        }

        return [];
    },

    // On change
    onFormChanged
));

const incomeSources = ref(useEditableList<GeorgiaDfcsBenefits.Income>(
    () => moduleState.value!.application.income! as DeepPartial<GeorgiaDfcsBenefits.Income>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<GeorgiaDfcsBenefits.Income>) => {
        if (item.name!.length == 0) return ["Please indicate who receives the income"];
        if (item.type!.length == 0) return ["Please enter income type"];
        if (item.source!.length == 0) return ["Please enter employer name / income source"];
        if (!item.monthlyAmount) return ["Please enter monthly amount"];
        if (!item.frequency) return ["Please enter frequency"];
        if (item.datesPaid!.length == 0) return ["Please indicate when the income is paid"];
        return [];
    },

    // On change
    onFormChanged
));

const careExpenses = ref(useEditableList<GeorgiaDfcsBenefits.CareExpense>(
    () => moduleState.value!.application.expenses!.careExpenses! as DeepPartial<GeorgiaDfcsBenefits.CareExpense>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<GeorgiaDfcsBenefits.CareExpense>) => {
        if (item.recipientName!.length == 0) return ["Please indicate who receives the care"];
        if (item.payerName!.length == 0) return ["Please indicate who pays for the care"];
        if (item.reason!.length == 0) return ["Please enter reason / type of care"];
        if (item.provider!.length == 0) return ["Please enter provider information"];
        if (!item.amount) return ["Please enter amount paid"];
        if (!item.frequency) return ["Please enter payment frequency"];
        return [];
    },

    // On change
    onFormChanged
));

const medicalExpenses = ref(useEditableList<GeorgiaDfcsBenefits.MedicalExpense>(
    () => moduleState.value!.application.expenses!.medicalExpenses! as DeepPartial<GeorgiaDfcsBenefits.MedicalExpense>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<GeorgiaDfcsBenefits.MedicalExpense>) => {
        if (item.name!.length == 0) return ["Please indicate who has this expense"];
        if (item.type!.length == 0) return ["Please enter type of expense"];
        if (!item.amount) return ["Please enter amount of expense"];
        if (item.stillOwed === undefined) return ["Please indicate whether this expense is still owed"];
        if (item.willInsurancePay === undefined) return ["Please indicate whether the expense is covered by insurance"];
        return [];
    },

    // On change
    onFormChanged
));

const medicalTransportationExpenses = ref(useEditableList<GeorgiaDfcsBenefits.MedicalTransportationExpense>(
    () => moduleState.value!.application.expenses!.medicalTransportationExpenses! as DeepPartial<GeorgiaDfcsBenefits.MedicalTransportationExpense>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<GeorgiaDfcsBenefits.MedicalTransportationExpense>) => {
        if (item.purpose!.length == 0) return ["Please enter the purpose of the trip"];
        if (!item.milesDriven) return ["Please enter the miles travelled"];
        if (!item.cost) return ["Please enter the cost"];
        return [];
    },

    // On change
    onFormChanged
));

const childSupportExpenses = ref(useEditableList<GeorgiaDfcsBenefits.ChildSupportExpense>(
    () => moduleState.value!.application.expenses!.childSupportExpenses! as DeepPartial<GeorgiaDfcsBenefits.ChildSupportExpense>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<GeorgiaDfcsBenefits.ChildSupportExpense>) => {
        if (item.childName!.length == 0) return ["Please indicate the child's name"];
        if (item.payerName!.length == 0) return ["Please indicate who pays"];
        if (!item.obligatedAmount) return ["Please enter the amount they are obligated to pay"];
        if (!item.actualAmount) return ["Please enter the amount which was actually paid"];
        if (item.recipientName!.length == 0) return ["Please indicate who receives the payment"];
        return [];
    },

    // On change
    onFormChanged
));

const supportDocuments = ref(useEditableList<SupportDocument>(
    () => moduleState.value!.supportDocuments as DeepPartial<SupportDocument>[], // Items
    () => { return {} }, // Create new item

    // Validate
    (item: DeepPartial<SupportDocument>) => {
        if (item.type!.length == 0) return ["Please enter the document type"];
        if (!item.front) return ["Please upload the front image"];
        return [];
    },

    // On change
    onFormChanged
));

const uploadSupportDocument = (sd: SupportDocument, side: "front"|"back", uploadInfo: {file: File, onDone: ()=>any}) => {
    uploadFile(uploadInfo.file, ['IMAGE','PDF'])
    .then(doc => {
        sd[side] = doc;
        supportDocuments.value.errors = [];
    })
    .catch(err => notifyNetworkError("Failed to upload document", err))
    .finally(() => uploadInfo.onDone());
}


return (_ctx: any,_cache: any) => {
  const _component_SaveButton = _resolveComponent("SaveButton")!
  const _component_FormCheckboxField = _resolveComponent("FormCheckboxField")!
  const _component_FormRadioGroupField = _resolveComponent("FormRadioGroupField")!
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_Columns = _resolveComponent("Columns")!
  const _component_HalfColumn = _resolveComponent("HalfColumn")!
  const _component_FormDateField = _resolveComponent("FormDateField")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!
  const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget")!
  const _component_AppPageFrame = _resolveComponent("AppPageFrame")!

  return (_openBlock(), _createBlock(_component_AppPageFrame, {
    showHeader: "",
    login: "require"
  }, {
    default: _withCtx(() => [
      (!form.value || !_unref(moduleState) || !draftId.value)
        ? (_openBlock(), _createBlock(LoadingPage, { key: 0 }))
        : (_unref(availableApplicationTypes).length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_SaveButton, {
                  large: "",
                  label: "Return To Home Page",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_unref(currentSection))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("h1", null, _toDisplayString(_unref(currentSection)?.name), 1),
                    (_unref(currentSection) != null)
                      ? (_openBlock(), _createElementBlock("progress", {
                          key: 0,
                          class: "progress is-primary mt-5",
                          value: 5 + _unref(currentSection).progress * 90,
                          max: "100"
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'selectBenefitTypes' && _unref(moduleState).application.selectedBenefits)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "Food Stamps",
                      modelValue: _unref(moduleState).application.selectedBenefits.foodStamps,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(moduleState).application.selectedBenefits.foodStamps) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "Temporary Assistance for Needs Families (TANF)",
                      modelValue: _unref(moduleState).application.selectedBenefits.TANF,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(moduleState).application.selectedBenefits.TANF) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormCheckboxField, {
                      class: "ml-3",
                      boxLabel: "Grandparents Raising Grandchildren (GRG)",
                      isDisabled: !_unref(moduleState).application.selectedBenefits.TANF,
                      modelValue: _unref(moduleState).application.selectedBenefits.GRG,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(moduleState).application.selectedBenefits.GRG) = $event))
                    }, null, 8, ["isDisabled", "modelValue"]),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "Refugee Cash Assistance",
                      modelValue: _unref(moduleState).application.selectedBenefits.refugeeCashAssistance,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(moduleState).application.selectedBenefits.refugeeCashAssistance) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "Medicaid",
                      modelValue: _unref(moduleState).application.selectedBenefits.medicaid,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(moduleState).application.selectedBenefits.medicaid) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "Register To Vote",
                      modelValue: _unref(moduleState).application.voterRegistrationIntent,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(moduleState).application.voterRegistrationIntent) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'tanfWaiver')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _hoisted_12,
                      (!_unref(moduleState).miscState.tanfWaiver.confirmed)
                        ? (_openBlock(), _createBlock(_component_SaveButton, {
                            key: 0,
                            class: "mt-5",
                            icon: "fa-square",
                            label: "Click To Agree",
                            large: "",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(moduleState).miscState.tanfWaiver.confirmed = true))
                          }))
                        : (_openBlock(), _createBlock(_component_SaveButton, {
                            key: 1,
                            class: "mt-5",
                            icon: "fa-check-square",
                            label: "I Agree",
                            large: "",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(moduleState).miscState.tanfWaiver.confirmed = false))
                          }))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'generalWaiver')
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _hoisted_16,
                      (!_unref(moduleState).miscState.generalWaiver.confirmed)
                        ? (_openBlock(), _createBlock(_component_SaveButton, {
                            key: 0,
                            class: "mt-5",
                            icon: "fa-square",
                            label: "Click To Agree",
                            large: "",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(moduleState).miscState.generalWaiver.confirmed = true))
                          }))
                        : (_openBlock(), _createBlock(_component_SaveButton, {
                            key: 1,
                            class: "mt-5",
                            icon: "fa-check-square",
                            label: "I Agree",
                            large: "",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(moduleState).miscState.generalWaiver.confirmed = false))
                          }))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'authorizedRepresentative' && _unref(moduleState).application.authorizedRepresentatives)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _hoisted_18,
                    _hoisted_19,
                    _hoisted_20,
                    (_unref(moduleState).application.selectedBenefits!.foodStamps)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, "They will also be able to use your EBT (Food Stamps) card to buy food when you cannot go to the store yourself."))
                      : _createCommentVNode("", true),
                    _createVNode(AuthorizedRepresentativeEditor, {
                      ref_key: "authorizedRep1Field",
                      ref: authorizedRep1Field,
                      prompt: "Would you like to add an authorized representative? *",
                      modelValue: _unref(moduleState).application.authorizedRepresentatives.first,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(moduleState).application.authorizedRepresentatives.first) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'authorizedRepresentative2' && _unref(moduleState).application.authorizedRepresentatives)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(AuthorizedRepresentativeEditor, {
                      ref_key: "authorizedRep2Field",
                      ref: authorizedRep2Field,
                      prompt: "Would you like to add a second authorized representative? *",
                      modelValue: _unref(moduleState).application.authorizedRepresentatives.second,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(moduleState).application.authorizedRepresentatives.second) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'authorizedRepresentativeSettings' && _unref(moduleState).application.authorizedRepresentatives)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_FormRadioGroupField, {
                      label: "Would you like your representative(s) to have a copy of your Medicaid card? *",
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).application.authorizedRepresentatives.toReceiveMedicaidCard,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(moduleState).application.authorizedRepresentatives.toReceiveMedicaidCard) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(RequiredAssistanceEditor, {
                      requiredLabel: "My representative(s) require additional assistance (sign language, braille, etc)",
                      whichTypesLabel: "Please indicate which assistance they require",
                      frequencyLabel: "Please briefly describe when they require this assistance",
                      modelValue: _unref(moduleState).application.authorizedRepresentatives.requiredAssistance,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(moduleState).application.authorizedRepresentatives.requiredAssistance) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'basicCitizenInfo' && _unref(moduleState).application.applicant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "First Name *",
                          modelValue: _unref(moduleState).application.applicant.firstName,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(moduleState).application.applicant.firstName) = $event)),
                          trimmed: "",
                          autoFocus: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Middle Initial",
                          modelValue: _unref(moduleState).application.applicant.middleInitial,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(moduleState).application.applicant.middleInitial) = $event)),
                          trimmed: "",
                          length: 1
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Last Name *",
                          modelValue: _unref(moduleState).application.applicant.lastName,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(moduleState).application.applicant.lastName) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Suffix",
                          modelValue: _unref(moduleState).application.applicant.suffix,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(moduleState).application.applicant.suffix) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_FormTextField, {
                      label: "Social Security Number *",
                      modelValue: _unref(moduleState).application.applicant.socialSecurityNumber,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(moduleState).application.applicant.socialSecurityNumber) = $event)),
                      trimmed: "",
                      length: 9
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_FormRadioGroupField, {
                      label: "Are you a US citizen, or qualified immigrant? *",
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).application.applicant.isUSCitizenOrQualifiedImmigrant,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(moduleState).application.applicant.isUSCitizenOrQualifiedImmigrant) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_28,
                    _createVNode(_component_HalfColumn, null, {
                      default: _withCtx(() => [
                        _createVNode(FormSelectField, {
                          label: "Your Sex / Gender *",
                          options: _unref(ProfileTypes).Sex,
                          allowNullSelection: "",
                          modelValue: _unref(moduleState).application.applicant.sex,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(moduleState).application.applicant.sex) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormDateField, {
                          label: "Date Of Birth *",
                          modelValue: _unref(moduleState).application.applicant.dateOfBirth,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(moduleState).application.applicant.dateOfBirth) = $event)),
                          past: ""
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_29, [
                          (_unref(moduleState).application.applicant.dateOfBirth)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("strong", null, _toDisplayString(_unref(formatAge)(_unref(moduleState).application.applicant.dateOfBirth as Date)), 1),
                                _hoisted_32
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'address' && _unref(moduleState).application.applicant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _hoisted_34,
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: `I have no fixed address - use ${_unref(sessionState).session!.user.assignedCareProvider!.name} address instead`,
                      modelValue: _unref(moduleState).application.applicant.useCareProviderAddressForMailing,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(moduleState).application.applicant.useCareProviderAddressForMailing) = $event))
                    }, null, 8, ["boxLabel", "modelValue"]),
                    (!_unref(moduleState).application.applicant.useCareProviderAddressForMailing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Building Number / Name *",
                                modelValue: _unref(moduleState).application.applicant.mailingAddress!.number,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(moduleState).application.applicant.mailingAddress!.number) = $event)),
                                autoFocus: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_FormTextField, {
                                label: "Street *",
                                modelValue: _unref(moduleState).application.applicant.mailingAddress!.street,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(moduleState).application.applicant.mailingAddress!.street) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "City *",
                                modelValue: _unref(moduleState).application.applicant.mailingAddress!.city,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(moduleState).application.applicant.mailingAddress!.city) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_FormTextField, {
                                label: "Zip Code *",
                                modelValue: _unref(moduleState).application.applicant.mailingAddress!.postalCode,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(moduleState).application.applicant.mailingAddress!.postalCode) = $event)),
                                numeric: "",
                                length: 9
                              }, null, 8, ["modelValue"]),
                              _createVNode(FormSelectField, {
                                label: "State *",
                                options: _unref(ProfileTypes).StateNotUnknown,
                                allowNullSelection: "",
                                modelValue: _unref(moduleState).application.applicant.mailingAddress!.state,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(moduleState).application.applicant.mailingAddress!.state) = $event))
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'contactInfo' && _unref(moduleState).application.applicant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "Main Phone Number",
                          modelValue: _unref(moduleState).application.applicant.mainPhone,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(moduleState).application.applicant.mainPhone) = $event)),
                          autoFocus: "",
                          trimmed: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Alternate Phone Number",
                          modelValue: _unref(moduleState).application.applicant.otherPhone,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(moduleState).application.applicant.otherPhone) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "I'm happy for the benefits office to contact me via SMS",
                      modelValue: _unref(moduleState).application.applicant.smsCommunicationPreferred,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(moduleState).application.applicant.smsCommunicationPreferred) = $event))
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_HalfColumn, { class: "mt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "Email Address",
                          modelValue: _unref(moduleState).application.applicant.email,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(moduleState).application.applicant.email) = $event)),
                          trimmed: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "I'm happy for the benefits office to contact me via email",
                      modelValue: _unref(moduleState).application.applicant.emailCommunicationPreferred,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(moduleState).application.applicant.emailCommunicationPreferred) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'communicationPreferences' && _unref(moduleState).application.applicant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_Columns, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FormTextField, {
                          label: "Preferred language *",
                          modelValue: _unref(moduleState).application.applicant.preferredLanguage,
                          "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(moduleState).application.applicant.preferredLanguage) = $event)),
                          autoFocus: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormCheckboxField, {
                          class: "mt-5",
                          boxLabel: "I need an interpreter",
                          modelValue: _unref(moduleState).application.applicant.interpreterNeeded,
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(moduleState).application.applicant.interpreterNeeded) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(RequiredAssistanceEditor, {
                      requiredLabel: "I require additional assistance (sign language, braille, etc)",
                      whichTypesLabel: "Please indicate which assistance you require",
                      frequencyLabel: "Please briefly describe when you require this assistance",
                      modelValue: _unref(moduleState).application.applicant.requiredAssistance,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(moduleState).application.applicant.requiredAssistance) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'householdMembers' && _unref(moduleState).application.householdMembers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(ListEditor, {
                      class: "mt-3",
                      headerLabel: "Household Members",
                      items: _unref(moduleState).application.householdMembers,
                      fixedItemLabel: `${_unref(formatName)(_unref(moduleState).application.applicant!.firstName!, _unref(moduleState).application.applicant!.middleInitial, _unref(moduleState).application.applicant!.lastName!)} (applicant)`,
                      itemIcon: "fa-user",
                      itemLabel: (item)=>_unref(formatName)(item.firstName!, item.middleInitial, item.lastName!),
                      addLabel: "Add",
                      onAdd: ()=>householdMembers.value.add(),
                      onEdit: (idx)=>householdMembers.value.edit(idx),
                      onRemove: (idx)=>householdMembers.value.remove(idx)
                    }, null, 8, ["items", "fixedItemLabel", "itemLabel", "onAdd", "onEdit", "onRemove"]),
                    (householdMembers.value.activeItem)
                      ? (_openBlock(), _createBlock(_component_ModalDialog, {
                          key: 0,
                          active: "",
                          title: "Household Member",
                          severity: "link",
                          firstButtonText: "Cancel",
                          firstButtonSeverity: "danger",
                          onFirstbuttonselected: _cache[37] || (_cache[37] = ($event: any) => (householdMembers.value.activeItem = null)),
                          secondButtonText: "Save",
                          secondButtonSeverity: "link",
                          onSecondbuttonselected: _cache[38] || (_cache[38] = ($event: any) => (householdMembers.value.onEditComplete()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([householdMembers.value.activeItem], (item, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx /* Defining 'item' alias */,
                                class: "modalScrollContainer"
                              }, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "First Name *",
                                      modelValue: item.firstName,
                                      "onUpdate:modelValue": ($event: any) => ((item.firstName) = $event),
                                      trimmed: "",
                                      autoFocus: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Middle Initial",
                                      modelValue: item.middleInitial,
                                      "onUpdate:modelValue": ($event: any) => ((item.middleInitial) = $event),
                                      trimmed: "",
                                      length: 1
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Last Name *",
                                      modelValue: item.lastName,
                                      "onUpdate:modelValue": ($event: any) => ((item.lastName) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormDateField, {
                                      label: "Date Of Birth *",
                                      modelValue: item.dateOfBirth,
                                      "onUpdate:modelValue": ($event: any) => ((item.dateOfBirth) = $event),
                                      past: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createElementVNode("div", _hoisted_42, [
                                      (item.dateOfBirth)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                                            _hoisted_44,
                                            _createElementVNode("strong", null, _toDisplayString(_unref(formatAge)(item.dateOfBirth as Date)), 1),
                                            _hoisted_45
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(FormSelectField, {
                                      label: "Sex / Gender *",
                                      options: _unref(ProfileTypes).Sex,
                                      allowNullSelection: "",
                                      modelValue: item.sex,
                                      "onUpdate:modelValue": ($event: any) => ((item.sex) = $event)
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                                    _createVNode(FormSelectField, {
                                      label: "Race / Ethnicity *",
                                      options: _unref(GeorgiaDfcsBenefits).Race,
                                      allowNullSelection: "",
                                      modelValue: item.race,
                                      "onUpdate:modelValue": ($event: any) => ((item.race) = $event)
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_HalfColumn, null, {
                                  default: _withCtx(() => [
                                    _createVNode(FormSelectField, {
                                      label: "What is this person's relationship to you? *",
                                      options: _unref(GeorgiaDfcsBenefits).Relationship,
                                      allowNullSelection: "",
                                      modelValue: item.relationship,
                                      "onUpdate:modelValue": ($event: any) => ((item.relationship) = $event)
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_FormRadioGroupField, {
                                  label: "Is this person applying for benefits? *",
                                  options: {'Yes': true, 'No': false},
                                  modelValue: item.isApplyingForBenefits,
                                  "onUpdate:modelValue": ($event: any) => ((item.isApplyingForBenefits) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                (item.isApplyingForBenefits)
                                  ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_FormTextField, {
                                          label: "Social Security Number *",
                                          modelValue: item.socialSecurityNumber,
                                          "onUpdate:modelValue": ($event: any) => ((item.socialSecurityNumber) = $event),
                                          trimmed: "",
                                          length: 9
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                (item.isApplyingForBenefits)
                                  ? (_openBlock(), _createBlock(_component_FormRadioGroupField, {
                                      key: 1,
                                      label: "Is this household member a US citizen, or qualified immigrant? *",
                                      options: {'Yes': true, 'No': false},
                                      modelValue: item.isUSCitizenOrQualifiedImmigrant,
                                      "onUpdate:modelValue": ($event: any) => ((item.isUSCitizenOrQualifiedImmigrant) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                  : _createCommentVNode("", true),
                                (householdMembers.value.errors.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(householdMembers.value.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_47))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'foodStampsQualificationQuestions')
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _hoisted_49,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(moduleState)!.application.expeditedFoodStampQualification!], (qs, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx /* Defining 'qs' alias */
                      }, [
                        _createVNode(_component_FormRadioGroupField, {
                          label: "Are you, or any household members, migrant or seasonal farm workers? *",
                          options: {'Yes': true, 'No': false},
                          modelValue: qs.isMigrantOrSeasonalFarmWorker,
                          "onUpdate:modelValue": ($event: any) => ((qs.isMigrantOrSeasonalFarmWorker) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (qs.isMigrantOrSeasonalFarmWorker)
                          ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FormTextField, {
                                  label: "Who? *",
                                  modelValue: qs.whoMigrantOrSeasonalFarmWorker,
                                  "onUpdate:modelValue": ($event: any) => ((qs.whoMigrantOrSeasonalFarmWorker) = $event),
                                  trimmed: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _hoisted_50,
                        _createVNode(_component_FormTextField, {
                          label: "What is your total earned income expected for this month (from employment - before tax) ($)? *",
                          modelValue: qs.totalEarnedIncomeThisMonth,
                          "onUpdate:modelValue": ($event: any) => ((qs.totalEarnedIncomeThisMonth) = $event),
                          numeric: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (qs.totalEarnedIncomeThisMonth! > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              _createVNode(_component_Columns, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormTextField, {
                                    label: "Employer name *",
                                    modelValue: qs.employerName,
                                    "onUpdate:modelValue": ($event: any) => ((qs.employerName) = $event),
                                    trimmed: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_FormTextField, {
                                    label: "How many hours do you work per week? *",
                                    modelValue: qs.employmentHoursPerWeek,
                                    "onUpdate:modelValue": ($event: any) => ((qs.employmentHoursPerWeek) = $event),
                                    numeric: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_Columns, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormTextField, {
                                    label: "Employment begin date *",
                                    modelValue: qs.employmentBeginDate,
                                    "onUpdate:modelValue": ($event: any) => ((qs.employmentBeginDate) = $event),
                                    trimmed: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_FormTextField, {
                                    label: "Employment end date *",
                                    modelValue: qs.employmentEndDate,
                                    "onUpdate:modelValue": ($event: any) => ((qs.employmentEndDate) = $event),
                                    trimmed: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_Columns, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormTextField, {
                                    label: "Usual payment amount ($) *",
                                    modelValue: qs.employmentPayRate,
                                    "onUpdate:modelValue": ($event: any) => ((qs.employmentPayRate) = $event),
                                    numeric: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(FormSelectField, {
                                    label: "Payment frequency *",
                                    options: _unref(GeorgiaDfcsBenefits).PaymentFrequency,
                                    modelValue: qs.earnedIncomeFrequency,
                                    "onUpdate:modelValue": ($event: any) => ((qs.earnedIncomeFrequency) = $event)
                                  }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_52,
                        _createVNode(_component_FormTextField, {
                          label: "What is your total unearned income expected for this month (income from other sources, such as welfare payments, child support, inheritance, or pension - before tax) ($)? *",
                          modelValue: qs.totalUnearnedIncomeThisMonth,
                          "onUpdate:modelValue": ($event: any) => ((qs.totalUnearnedIncomeThisMonth) = $event),
                          numeric: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (qs.totalUnearnedIncomeThisMonth && qs.totalUnearnedIncomeThisMonth > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createVNode(_component_HalfColumn, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormTextField, {
                                    label: "Income type / source *",
                                    modelValue: qs.firstUnearnedIncomeType,
                                    "onUpdate:modelValue": ($event: any) => ((qs.firstUnearnedIncomeType) = $event),
                                    trimmed: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_Columns, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormTextField, {
                                    label: "Usual payment amount ($) *",
                                    modelValue: qs.firstUnearnedIncomeAmount,
                                    "onUpdate:modelValue": ($event: any) => ((qs.firstUnearnedIncomeAmount) = $event),
                                    numeric: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createVNode(FormSelectField, {
                                    label: "Payment frequency *",
                                    options: _unref(GeorgiaDfcsBenefits).PaymentFrequency,
                                    modelValue: qs.firstUnearnedIncomeFrequency,
                                    "onUpdate:modelValue": ($event: any) => ((qs.firstUnearnedIncomeFrequency) = $event)
                                  }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_HalfColumn, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormCheckboxField, {
                                    boxLabel: "I have another source of unearned income",
                                    modelValue: _unref(moduleState).miscState.foodStampsQualificationQuestions.hasSecondUnearnedIncome,
                                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(moduleState).miscState.foodStampsQualificationQuestions.hasSecondUnearnedIncome) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              (_unref(moduleState).miscState.foodStampsQualificationQuestions.hasSecondUnearnedIncome)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _createVNode(_component_HalfColumn, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_FormTextField, {
                                          label: "Income type / source *",
                                          modelValue: qs.secondUnearnedIncomeType,
                                          "onUpdate:modelValue": ($event: any) => ((qs.secondUnearnedIncomeType) = $event),
                                          trimmed: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_Columns, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_FormTextField, {
                                          label: "Usual payment amount ($) *",
                                          modelValue: qs.secondUnearnedIncomeAmount,
                                          "onUpdate:modelValue": ($event: any) => ((qs.secondUnearnedIncomeAmount) = $event),
                                          numeric: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(FormSelectField, {
                                          label: "Payment frequency *",
                                          options: _unref(GeorgiaDfcsBenefits).PaymentFrequency,
                                          modelValue: qs.secondUnearnedIncomeFrequency,
                                          "onUpdate:modelValue": ($event: any) => ((qs.secondUnearnedIncomeFrequency) = $event)
                                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_55,
                        _createVNode(_component_FormTextField, {
                          label: "What is your total earned and unearned income expected for this month (income from all sources, before tax) ($)? *",
                          modelValue: qs.totalIncomeThisMonth,
                          "onUpdate:modelValue": ($event: any) => ((qs.totalIncomeThisMonth) = $event),
                          numeric: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "How much money do you and all household members have in cash or in the bank ($)? *",
                          modelValue: qs.totalMoneyInCashAndBank,
                          "onUpdate:modelValue": ($event: any) => ((qs.totalMoneyInCashAndBank) = $event),
                          numeric: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _hoisted_56,
                        _createVNode(_component_FormTextField, {
                          label: "What is the monthly total you pay for rent, mortgage, property taxes, and/or homeowners insurance ($)? *",
                          modelValue: qs.totalRentOrMortgagePayment,
                          "onUpdate:modelValue": ($event: any) => ((qs.totalRentOrMortgagePayment) = $event),
                          numeric: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "What is the monthly total you pay for electric, water, gas, and/or other utilities (exclude any late fees or other repayments) ($)? *",
                          modelValue: qs.totalUtilitiesPayment,
                          "onUpdate:modelValue": ($event: any) => ((qs.totalUtilitiesPayment) = $event),
                          numeric: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormCheckboxField, {
                          boxLabel: "Our household uses electric for heating",
                          modelValue: qs.hasElectricUtilities,
                          "onUpdate:modelValue": ($event: any) => ((qs.hasElectricUtilities) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormCheckboxField, {
                          boxLabel: "Our household uses gas for heating",
                          modelValue: qs.hasGasUtilities,
                          "onUpdate:modelValue": ($event: any) => ((qs.hasGasUtilities) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormCheckboxField, {
                          boxLabel: "Our household uses window or central air conditioning",
                          modelValue: qs.hasAirConUtilities,
                          "onUpdate:modelValue": ($event: any) => ((qs.hasAirConUtilities) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormCheckboxField, {
                          boxLabel: "Our household uses kerosene oil heating",
                          modelValue: qs.hasKeroseneUtilities,
                          "onUpdate:modelValue": ($event: any) => ((qs.hasKeroseneUtilities) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormCheckboxField, {
                          boxLabel: "Our household uses wood for heating",
                          modelValue: qs.hasWoodUtilities,
                          "onUpdate:modelValue": ($event: any) => ((qs.hasWoodUtilities) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_FormRadioGroupField, {
                          class: "mt-3",
                          label: "Have you received energy assistance in the last 12 months? *",
                          options: {'Yes': true, 'No': false},
                          modelValue: qs.hasReceivedEnergyAssistance,
                          "onUpdate:modelValue": ($event: any) => ((qs.hasReceivedEnergyAssistance) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (qs.hasReceivedEnergyAssistance)
                          ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 3 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FormTextField, {
                                  label: "What amount did you receive ($)? *",
                                  modelValue: qs.energyAssistanceAmount,
                                  "onUpdate:modelValue": ($event: any) => ((qs.energyAssistanceAmount) = $event),
                                  numeric: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'additionalQualificationQuestions')
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _hoisted_58,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_unref(moduleState)!.application.additionalQualifications!], (qs, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: idx /* Defining 'qs' alias */
                      }, [
                        _createVNode(_component_FormRadioGroupField, {
                          label: "Has anyone received any benefits in another county or state? *",
                          options: {'Yes': true, 'No': false},
                          modelValue: qs.hasBenefitsFromOtherCountyOrState,
                          "onUpdate:modelValue": ($event: any) => ((qs.hasBenefitsFromOtherCountyOrState) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        (qs.hasBenefitsFromOtherCountyOrState)
                          ? (_openBlock(), _createBlock(_component_Columns, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_FormTextField, {
                                  label: "Who? *",
                                  modelValue: qs.whoBenefitsFromOtherCountyOrState,
                                  "onUpdate:modelValue": ($event: any) => ((qs.whoBenefitsFromOtherCountyOrState) = $event),
                                  trimmed: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_FormTextField, {
                                  label: "Where? *",
                                  modelValue: qs.whereBenefitsFromOtherCountyOrState,
                                  "onUpdate:modelValue": ($event: any) => ((qs.whereBenefitsFromOtherCountyOrState) = $event),
                                  trimmed: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_FormTextField, {
                                  label: "When? *",
                                  modelValue: qs.whenBenefitsFromOtherCountyOrState,
                                  "onUpdate:modelValue": ($event: any) => ((qs.whenBenefitsFromOtherCountyOrState) = $event),
                                  trimmed: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (_unref(moduleState)!.application.selectedBenefits!.foodStamps)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                              _hoisted_60,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Has anyone been convicted of giving false information about where they live or who they are to get multiple Food Stamps benefits in more than one area after 8/22/96? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasFalseInformationBenefitsConvicion,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasFalseInformationBenefitsConvicion) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasFalseInformationBenefitsConvicion)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoFalseInformationBenefitsConvicion,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoFalseInformationBenefitsConvicion) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "Where? *",
                                        modelValue: qs.whereFalseInformationBenefitsConvicion,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whereFalseInformationBenefitsConvicion) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "When? *",
                                        modelValue: qs.whenFalseInformationBenefitsConvicion,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whenFalseInformationBenefitsConvicion) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_61,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Has anyone been convicted of trading Food Stamp benefits for drugs after 8/22/96? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasFoodStampDrugTradingConviction,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasFoodStampDrugTradingConviction) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasFoodStampDrugTradingConviction)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoFoodStampDrugTradingConviction,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoFoodStampDrugTradingConviction) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "When? *",
                                        modelValue: qs.whenFoodStampDrugTradingConviction,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whenFoodStampDrugTradingConviction) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_62,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Has anyone been convicted of buying or selling Food Stamp benefits over $500 after 8/22/96? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasFoodStampSellingConviction,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasFoodStampSellingConviction) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasFoodStampSellingConviction)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoFoodStampSellingConviction,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoFoodStampSellingConviction) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "When? *",
                                        modelValue: qs.whenFoodStampSellingConviction,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whenFoodStampSellingConviction) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_63,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Have you or any household member been convicted of trading Food Stamp benefits for guns, ammunition or explosives after 8/22/96? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasFoodStampWeaponsTradingConviction,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasFoodStampWeaponsTradingConviction) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasFoodStampWeaponsTradingConviction)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 3 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoFoodStampWeaponsTradingConviction,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoFoodStampWeaponsTradingConviction) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "When? *",
                                        modelValue: qs.whenFoodStampWeaponsTradingConviction,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whenFoodStampWeaponsTradingConviction) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_64,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Has anyone received lottery or gambling winnings? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasGamblingWinnings,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasGamblingWinnings) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasGamblingWinnings)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 4 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoGamblingWinnings,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoGamblingWinnings) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "When? *",
                                        modelValue: qs.whenGamblingWinnings,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whenGamblingWinnings) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "Amount received *",
                                        modelValue: qs.gamblingWinningsAmount,
                                        "onUpdate:modelValue": ($event: any) => ((qs.gamblingWinningsAmount) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(moduleState)!.application.selectedBenefits!.foodStamps || _unref(moduleState)!.application.selectedBenefits!.TANF)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _hoisted_66,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Did anyone in your household voluntarily quit a job, or voluntarily reduce their work hours below 30 hours per week, within the last 30 days? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasVoluntarilyQuitOrReducedHours,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasVoluntarilyQuitOrReducedHours) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasVoluntarilyQuitOrReducedHours)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoVoluntarilyQuitOrReducedHours,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoVoluntarilyQuitOrReducedHours) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "Why? *",
                                        modelValue: qs.whyVoluntarilyQuitOrReducedHours,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whyVoluntarilyQuitOrReducedHours) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_67,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Is anyone disqualified from the Food Stamp or TANF Program? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasFoodStampOrTANFDisqualification,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasFoodStampOrTANFDisqualification) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasFoodStampOrTANFDisqualification)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoFoodStampOrTANFDisqualification,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoFoodStampOrTANFDisqualification) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "Where? *",
                                        modelValue: qs.whereFoodStampOrTANFDisqualification,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whereFoodStampOrTANFDisqualification) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_68,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Is anyone trying to avoid prosecution or jail for a felony? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.isAvoidingProsecutionOrJail,
                                "onUpdate:modelValue": ($event: any) => ((qs.isAvoidingProsecutionOrJail) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.isAvoidingProsecutionOrJail)
                                ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 2 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoAvoidingProsecutionOrJail,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoAvoidingProsecutionOrJail) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_69,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Is anyone violating conditions of probation or parole? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasParoleViolation,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasParoleViolation) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasParoleViolation)
                                ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 3 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoParoleVoliation,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoParoleVoliation) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _hoisted_70,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Does anyone have a violent or drug-related felony conviction after 8/22/96? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasFelonyDrugOrViolenceConviction,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasFelonyDrugOrViolenceConviction) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasFelonyDrugOrViolenceConviction)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                    _createVNode(_component_Columns, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_FormTextField, {
                                          label: "Who? *",
                                          modelValue: qs.whoFelonyDrugOrViolenceConviction,
                                          "onUpdate:modelValue": ($event: any) => ((qs.whoFelonyDrugOrViolenceConviction) = $event),
                                          trimmed: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        _createVNode(_component_FormTextField, {
                                          label: "When? *",
                                          modelValue: qs.whenFelonyDrugOrViolenceConviction,
                                          "onUpdate:modelValue": ($event: any) => ((qs.whenFelonyDrugOrViolenceConviction) = $event),
                                          trimmed: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_FormRadioGroupField, {
                                      label: "Are you in compliance with all probation terms for any drug-related felony? *",
                                      options: {'Yes': true, 'No': false},
                                      modelValue: qs.isComplyingWithFelonyDrugOrViolenceConvictionProbationTerms,
                                      "onUpdate:modelValue": ($event: any) => ((qs.isComplyingWithFelonyDrugOrViolenceConvictionProbationTerms) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormRadioGroupField, {
                                      label: "Are you in compliance with all parole terms for any drug-related felony? *",
                                      options: {'Yes': true, 'No': false},
                                      modelValue: qs.isComplyingWithFelonyDrugOrViolenceConvictionParoleTerms,
                                      "onUpdate:modelValue": ($event: any) => ((qs.isComplyingWithFelonyDrugOrViolenceConvictionParoleTerms) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormRadioGroupField, {
                                      label: "Have you successfully completed ALL terms of probation or parole for any drug-related conviction? *",
                                      options: {'Yes': true, 'No': false},
                                      modelValue: qs.hasCompletedAllFelonyDrugOrViolenceConvictionTerms,
                                      "onUpdate:modelValue": ($event: any) => ((qs.hasCompletedAllFelonyDrugOrViolenceConvictionTerms) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(moduleState)!.application.selectedBenefits!.medicaid)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                              _hoisted_73,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Does anyone have any unpaid medical bills for the last 3 months? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasUnpaidMedicalBills,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasUnpaidMedicalBills) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(moduleState)!.application.selectedBenefits!.medicaid || _unref(moduleState)!.application.selectedBenefits!.TANF)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Is anyone pregnant? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.isPregnant,
                                "onUpdate:modelValue": ($event: any) => ((qs.isPregnant) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.isPregnant)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoPregnant,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoPregnant) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "What is their due date? *",
                                        modelValue: qs.pregnancyDueDate,
                                        "onUpdate:modelValue": ($event: any) => ((qs.pregnancyDueDate) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(moduleState)!.application.selectedBenefits!.TANF)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                              _hoisted_77,
                              _createVNode(_component_FormRadioGroupField, {
                                label: "Has anyone used TANF funds or the EPPIC Card at liquor stores, casinos, poker rooms, adult entertainment business, bail bonds, night clubs, salons/taverns, bingo halls, race tracks, gun/ammunition stores, cruise ships, psychic readers, smoking shops, tattoo/piercing shops or spa/massage salons? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: qs.hasMisusedTANF,
                                "onUpdate:modelValue": ($event: any) => ((qs.hasMisusedTANF) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              (qs.hasMisusedTANF)
                                ? (_openBlock(), _createBlock(_component_Columns, { key: 0 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_FormTextField, {
                                        label: "Who? *",
                                        modelValue: qs.whoMisusedTANF,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whoMisusedTANF) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                      _createVNode(_component_FormTextField, {
                                        label: "When? *",
                                        modelValue: qs.whenMisusedTANF,
                                        "onUpdate:modelValue": ($event: any) => ((qs.whenMisusedTANF) = $event),
                                        trimmed: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'income' && _unref(moduleState).application.income)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _hoisted_79,
                    _hoisted_80,
                    _hoisted_81,
                    _createVNode(ListEditor, {
                      class: "mt-3",
                      headerLabel: "Income Sources",
                      items: _unref(moduleState).application.income,
                      itemIcon: "fa-coins",
                      itemLabel: (item)=>`$${item.monthlyAmount}/mo from ${item.source} to ${item.name}`,
                      addLabel: "Add",
                      onAdd: ()=>incomeSources.value.add(),
                      onEdit: (idx)=>incomeSources.value.edit(idx),
                      onRemove: (idx)=>incomeSources.value.remove(idx)
                    }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"]),
                    (incomeSources.value.activeItem)
                      ? (_openBlock(), _createBlock(_component_ModalDialog, {
                          key: 0,
                          active: "",
                          title: "Income Source",
                          severity: "link",
                          firstButtonText: "Cancel",
                          firstButtonSeverity: "danger",
                          onFirstbuttonselected: _cache[40] || (_cache[40] = ($event: any) => (incomeSources.value.activeItem = null)),
                          secondButtonText: "Save",
                          secondButtonSeverity: "link",
                          onSecondbuttonselected: _cache[41] || (_cache[41] = ($event: any) => (incomeSources.value.onEditComplete()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([incomeSources.value.activeItem], (item, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx /* Defining 'item' alias */,
                                class: "modalScrollContainer"
                              }, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Who receives it? *",
                                      modelValue: item.name,
                                      "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                                      trimmed: "",
                                      autoFocus: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Monthly amount ($, before deductions) *",
                                      modelValue: item.monthlyAmount,
                                      "onUpdate:modelValue": ($event: any) => ((item.monthlyAmount) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Type of income *",
                                      placeholder: "e.g. wages, self-employment, benefits",
                                      modelValue: item.type,
                                      "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Income source *",
                                      placeholder: "e.g. employer name, type of benefit",
                                      modelValue: item.source,
                                      "onUpdate:modelValue": ($event: any) => ((item.source) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Hourly rate ($)",
                                      modelValue: item.hourlyRate,
                                      "onUpdate:modelValue": ($event: any) => ((item.hourlyRate) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Hours per week",
                                      modelValue: item.hoursPerWeek,
                                      "onUpdate:modelValue": ($event: any) => ((item.hoursPerWeek) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(FormSelectField, {
                                      label: "Payment frequency *",
                                      options: _unref(GeorgiaDfcsBenefits).PaymentFrequency,
                                      modelValue: item.frequency,
                                      "onUpdate:modelValue": ($event: any) => ((item.frequency) = $event)
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Dates paid *",
                                      modelValue: item.datesPaid,
                                      "onUpdate:modelValue": ($event: any) => ((item.datesPaid) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                (incomeSources.value.errors.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incomeSources.value.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_83))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'careExpenses' && _unref(moduleState).application.expenses?.careExpenses)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _hoisted_85,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).miscState.expenses.hasCareExpenses,
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(moduleState).miscState.expenses.hasCareExpenses) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.expenses.hasCareExpenses)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                          _hoisted_87,
                          _createVNode(ListEditor, {
                            class: "mt-3",
                            items: _unref(moduleState).application.expenses.careExpenses,
                            itemIcon: "fa-coins",
                            itemLabel: (item)=>`$${item.amount} for ${item.reason} to ${item.recipientName}`,
                            addLabel: "Add",
                            onAdd: ()=>careExpenses.value.add(),
                            onEdit: (idx)=>careExpenses.value.edit(idx),
                            onRemove: (idx)=>careExpenses.value.remove(idx)
                          }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"])
                        ]))
                      : _createCommentVNode("", true),
                    (careExpenses.value.activeItem)
                      ? (_openBlock(), _createBlock(_component_ModalDialog, {
                          key: 1,
                          active: "",
                          title: "Care Expense",
                          severity: "link",
                          firstButtonText: "Cancel",
                          firstButtonSeverity: "danger",
                          onFirstbuttonselected: _cache[43] || (_cache[43] = ($event: any) => (careExpenses.value.activeItem = null)),
                          secondButtonText: "Save",
                          secondButtonSeverity: "link",
                          onSecondbuttonselected: _cache[44] || (_cache[44] = ($event: any) => (careExpenses.value.onEditComplete()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([careExpenses.value.activeItem], (item, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx /* Defining 'item' alias */,
                                class: "modalScrollContainer"
                              }, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Who requires care? *",
                                      modelValue: item.recipientName,
                                      "onUpdate:modelValue": ($event: any) => ((item.recipientName) = $event),
                                      trimmed: "",
                                      autoFocus: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Who pays for the care? *",
                                      modelValue: item.payerName,
                                      "onUpdate:modelValue": ($event: any) => ((item.payerName) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Reason / type of care *",
                                      modelValue: item.reason,
                                      "onUpdate:modelValue": ($event: any) => ((item.reason) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Provider's name / number *",
                                      modelValue: item.provider,
                                      "onUpdate:modelValue": ($event: any) => ((item.provider) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Amount paid ($) *",
                                      modelValue: item.amount,
                                      "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(FormSelectField, {
                                      label: "Payment frequency *",
                                      options: _unref(GeorgiaDfcsBenefits).PaymentFrequency,
                                      modelValue: item.frequency,
                                      "onUpdate:modelValue": ($event: any) => ((item.frequency) = $event)
                                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                (careExpenses.value.errors.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(careExpenses.value.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_89))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'dependentTransportationExpenses' && _unref(moduleState).application.expenses)
                ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                    _hoisted_91,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).application.expenses.hasDependentTransportationExpenses,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_unref(moduleState).application.expenses.hasDependentTransportationExpenses) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).application.expenses.hasDependentTransportationExpenses)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                          (_unref(moduleState).miscState.expenses.hasCareExpenses)
                            ? (_openBlock(), _createBlock(_component_FormRadioGroupField, {
                                key: 0,
                                label: "Did you already include these expenses on the previous screen? *",
                                options: {'Yes': true, 'No': false},
                                modelValue: _unref(moduleState).application.expenses.areDependentTransportationExpensesIncluded,
                                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_unref(moduleState).application.expenses.areDependentTransportationExpensesIncluded) = $event))
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true),
                          (!_unref(moduleState).miscState.expenses.hasCareExpenses || _unref(moduleState).application.expenses.areDependentTransportationExpensesIncluded == false)
                            ? (_openBlock(), _createBlock(_component_FormTextField, {
                                key: 1,
                                label: "What is the total number of miles driven weekly? *",
                                modelValue: _unref(moduleState).application.expenses.totalMilesDrivenWeekly,
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_unref(moduleState).application.expenses.totalMilesDrivenWeekly) = $event)),
                                numeric: ""
                              }, null, 8, ["modelValue"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'medicalExpenses' && _unref(moduleState).application.expenses?.medicalExpenses)
                ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                    _hoisted_94,
                    _hoisted_95,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).miscState.expenses.hasMedicalExpenses,
                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_unref(moduleState).miscState.expenses.hasMedicalExpenses) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.expenses.hasMedicalExpenses)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          _hoisted_97,
                          _createVNode(ListEditor, {
                            class: "mt-3",
                            items: _unref(moduleState).application.expenses.medicalExpenses,
                            itemIcon: "fa-coins",
                            itemLabel: (item)=>`$${item.amount} for ${item.type} to ${item.name}`,
                            addLabel: "Add",
                            onAdd: ()=>medicalExpenses.value.add(),
                            onEdit: (idx)=>medicalExpenses.value.edit(idx),
                            onRemove: (idx)=>medicalExpenses.value.remove(idx)
                          }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"])
                        ]))
                      : _createCommentVNode("", true),
                    (medicalExpenses.value.activeItem)
                      ? (_openBlock(), _createBlock(_component_ModalDialog, {
                          key: 1,
                          active: "",
                          title: "Medical Expense",
                          severity: "link",
                          firstButtonText: "Cancel",
                          firstButtonSeverity: "danger",
                          onFirstbuttonselected: _cache[49] || (_cache[49] = ($event: any) => (medicalExpenses.value.activeItem = null)),
                          secondButtonText: "Save",
                          secondButtonSeverity: "link",
                          onSecondbuttonselected: _cache[50] || (_cache[50] = ($event: any) => (medicalExpenses.value.onEditComplete()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([medicalExpenses.value.activeItem], (item, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx /* Defining 'item' alias */,
                                class: "modalScrollContainer"
                              }, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Who has this expense? *",
                                      modelValue: item.name,
                                      "onUpdate:modelValue": ($event: any) => ((item.name) = $event),
                                      trimmed: "",
                                      autoFocus: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Type of expense (e.g. doctor visits, hospital visits, prescriptions...) *",
                                      modelValue: item.type,
                                      "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Amount ($) *",
                                      modelValue: item.amount,
                                      "onUpdate:modelValue": ($event: any) => ((item.amount) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Date paid (if applicable)",
                                      modelValue: item.datePaid,
                                      "onUpdate:modelValue": ($event: any) => ((item.datePaid) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_FormRadioGroupField, {
                                  label: "Is this money still owed? *",
                                  options: {'Yes': true, 'No': false},
                                  modelValue: item.stillOwed,
                                  "onUpdate:modelValue": ($event: any) => ((item.stillOwed) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_FormRadioGroupField, {
                                  label: "Is this expense covered by your insurance? *",
                                  options: {'Yes': true, 'No': false},
                                  modelValue: item.willInsurancePay,
                                  "onUpdate:modelValue": ($event: any) => ((item.willInsurancePay) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                (medicalExpenses.value.errors.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(medicalExpenses.value.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_99))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'medicalTransportationExpenses' && _unref(moduleState).application.expenses?.medicalTransportationExpenses)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    _hoisted_101,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).miscState.expenses.hasMedicalTransportationExpenses,
                      "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_unref(moduleState).miscState.expenses.hasMedicalTransportationExpenses) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.expenses.hasMedicalTransportationExpenses)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                          _hoisted_103,
                          _createVNode(ListEditor, {
                            class: "mt-3",
                            items: _unref(moduleState).application.expenses.medicalTransportationExpenses,
                            itemIcon: "fa-coins",
                            itemLabel: (item)=>`$${item.cost} for ${item.purpose}`,
                            addLabel: "Add",
                            onAdd: ()=>medicalTransportationExpenses.value.add(),
                            onEdit: (idx)=>medicalTransportationExpenses.value.edit(idx),
                            onRemove: (idx)=>medicalTransportationExpenses.value.remove(idx)
                          }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"])
                        ]))
                      : _createCommentVNode("", true),
                    (medicalTransportationExpenses.value.activeItem)
                      ? (_openBlock(), _createBlock(_component_ModalDialog, {
                          key: 1,
                          active: "",
                          title: "Medical Transportation Expense",
                          severity: "link",
                          firstButtonText: "Cancel",
                          firstButtonSeverity: "danger",
                          onFirstbuttonselected: _cache[52] || (_cache[52] = ($event: any) => (medicalTransportationExpenses.value.activeItem = null)),
                          secondButtonText: "Save",
                          secondButtonSeverity: "link",
                          onSecondbuttonselected: _cache[53] || (_cache[53] = ($event: any) => (medicalTransportationExpenses.value.onEditComplete()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([medicalTransportationExpenses.value.activeItem], (item, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx /* Defining 'item' alias */,
                                class: "modalScrollContainer"
                              }, [
                                _createVNode(_component_FormTextField, {
                                  label: "Purpose of the trip (e.g. doctor visit, hospital visit, pharmacy pick-up...) *",
                                  modelValue: item.purpose,
                                  "onUpdate:modelValue": ($event: any) => ((item.purpose) = $event),
                                  trimmed: "",
                                  autoFocus: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Total miles travelled * ",
                                      modelValue: item.milesDriven,
                                      "onUpdate:modelValue": ($event: any) => ((item.milesDriven) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Cost of transport, parking, lodging etc. ($) *",
                                      modelValue: item.cost,
                                      "onUpdate:modelValue": ($event: any) => ((item.cost) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                (medicalTransportationExpenses.value.errors.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(medicalTransportationExpenses.value.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_105))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'childSupportExpenses' && _unref(moduleState).application.expenses?.childSupportExpenses)
                ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                    _hoisted_107,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).miscState.expenses.hasChildSupportExpenses,
                      "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_unref(moduleState).miscState.expenses.hasChildSupportExpenses) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.expenses.hasChildSupportExpenses)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                          _hoisted_109,
                          _createVNode(ListEditor, {
                            class: "mt-3",
                            items: _unref(moduleState).application.expenses.childSupportExpenses,
                            itemIcon: "fa-coins",
                            itemLabel: (item)=>`$${item.obligatedAmount} for ${item.childName} to ${item.recipientName}`,
                            addLabel: "Add Child Support Expense",
                            onAdd: ()=>childSupportExpenses.value.add(),
                            onEdit: (idx)=>childSupportExpenses.value.edit(idx),
                            onRemove: (idx)=>childSupportExpenses.value.remove(idx)
                          }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"])
                        ]))
                      : _createCommentVNode("", true),
                    (childSupportExpenses.value.activeItem)
                      ? (_openBlock(), _createBlock(_component_ModalDialog, {
                          key: 1,
                          active: "",
                          title: "Child Support Expense",
                          severity: "link",
                          firstButtonText: "Cancel",
                          firstButtonSeverity: "danger",
                          onFirstbuttonselected: _cache[55] || (_cache[55] = ($event: any) => (childSupportExpenses.value.activeItem = null)),
                          secondButtonText: "Save",
                          secondButtonSeverity: "link",
                          onSecondbuttonselected: _cache[56] || (_cache[56] = ($event: any) => (childSupportExpenses.value.onEditComplete()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([childSupportExpenses.value.activeItem], (item, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx /* Defining 'item' alias */,
                                class: "modalScrollContainer"
                              }, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "What is the name of the child? *",
                                      modelValue: item.childName,
                                      "onUpdate:modelValue": ($event: any) => ((item.childName) = $event),
                                      trimmed: "",
                                      autoFocus: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "Who pays child support? *",
                                      modelValue: item.payerName,
                                      "onUpdate:modelValue": ($event: any) => ((item.payerName) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "How much are they obligated to pay ($)? *",
                                      modelValue: item.obligatedAmount,
                                      "onUpdate:modelValue": ($event: any) => ((item.obligatedAmount) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                    _createVNode(_component_FormTextField, {
                                      label: "How much did they actually pay ($)? *",
                                      modelValue: item.actualAmount,
                                      "onUpdate:modelValue": ($event: any) => ((item.actualAmount) = $event),
                                      numeric: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_HalfColumn, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "Who receives this payment? *",
                                      modelValue: item.recipientName,
                                      "onUpdate:modelValue": ($event: any) => ((item.recipientName) = $event),
                                      trimmed: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                (childSupportExpenses.value.errors.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childSupportExpenses.value.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_111))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'shelterOrUtilityExpenses' && _unref(moduleState).application.expenses?.shelterOrUtilityExpenses)
                ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                    _hoisted_113,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).miscState.expenses.hasShelterOrUtilityExpenses,
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_unref(moduleState).miscState.expenses.hasShelterOrUtilityExpenses) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.expenses.hasShelterOrUtilityExpenses)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                          _hoisted_115,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you pay rent / mortgage? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.rentOrMortgage,
                            "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.rentOrMortgage) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_116,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you pay property tax? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.propertyTax,
                            "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.propertyTax) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_117,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you pay property insurance? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.propertyInsurance,
                            "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.propertyInsurance) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_118,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you pay for electricity? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.electricity,
                            "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.electricity) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_119,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you pay for gas? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.gas,
                            "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.gas) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_120,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you pay for garbage disposal? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.garbage,
                            "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.garbage) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_121,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you pay for telephone? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.telephone,
                            "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.telephone) = $event))
                          }, null, 8, ["modelValue"]),
                          _hoisted_122,
                          _createVNode(ShelterOrUtilityExpenseEditor, {
                            prompt: "Do you have any other shelter or utility expenses? *",
                            modelValue: _unref(moduleState).application.expenses.shelterOrUtilityExpenses.other,
                            "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_unref(moduleState).application.expenses.shelterOrUtilityExpenses.other) = $event))
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'sharedExpenses' && _unref(moduleState).application.expenses?.sharedExpenses && _unref(moduleState).application.expenses?.sharedExpenses.landlordAddress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                    _hoisted_124,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).miscState.expenses.hasSharedExpenses,
                      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_unref(moduleState).miscState.expenses.hasSharedExpenses) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.expenses.hasSharedExpenses)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                          _createVNode(_component_FormTextField, {
                            label: "Who do you share expenses with? *",
                            modelValue: _unref(moduleState).application.expenses.sharedExpenses.who,
                            "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.who) = $event)),
                            trimmed: "",
                            autoFocus: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormTextField, {
                            label: "Please describe the arrangement *",
                            modelValue: _unref(moduleState).application.expenses.sharedExpenses.comments,
                            "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.comments) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormTextField, {
                            label: "Who do you pay to? *",
                            modelValue: _unref(moduleState).application.expenses.sharedExpenses.recipientName,
                            "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.recipientName) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Amount paid ($) *",
                                modelValue: _unref(moduleState).application.expenses.sharedExpenses.paymentAmount,
                                "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.paymentAmount) = $event)),
                                numeric: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(FormSelectField, {
                                label: "Payment frequency *",
                                options: _unref(GeorgiaDfcsBenefits).PaymentFrequency,
                                modelValue: _unref(moduleState).application.expenses.sharedExpenses.paymentFrequency,
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.paymentFrequency) = $event))
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_FormTextField, {
                            label: "Landlord's name *",
                            modelValue: _unref(moduleState).application.expenses.sharedExpenses.landlordName,
                            "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.landlordName) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Landlord's Building Number / Name",
                                modelValue: _unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.number,
                                "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.number) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_FormTextField, {
                                label: "Landlord's Street",
                                modelValue: _unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.street,
                                "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.street) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Columns, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_FormTextField, {
                                label: "Landlord's City",
                                modelValue: _unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.city,
                                "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.city) = $event)),
                                trimmed: ""
                              }, null, 8, ["modelValue"]),
                              _createVNode(FormSelectField, {
                                label: "Landlord's State",
                                options: _unref(ProfileTypes).StateNotUnknown,
                                allowNullSelection: "",
                                modelValue: _unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.state,
                                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_unref(moduleState).application.expenses.sharedExpenses.landlordAddress!.state) = $event))
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'otherBillPayer' && _unref(moduleState).application.expenses?.otherBillPayer)
                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    _hoisted_127,
                    _createVNode(_component_FormRadioGroupField, {
                      options: {'Yes': true, 'No': false},
                      modelValue: _unref(moduleState).miscState.expenses.hasOtherBillPayer,
                      "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_unref(moduleState).miscState.expenses.hasOtherBillPayer) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.expenses.hasOtherBillPayer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                          _createVNode(_component_FormTextField, {
                            label: "Who pays? *",
                            modelValue: _unref(moduleState).application.expenses.otherBillPayer.payerName,
                            "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_unref(moduleState).application.expenses.otherBillPayer.payerName) = $event)),
                            trimmed: "",
                            autoFocus: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormTextField, {
                            label: "Which bills do they pay? *",
                            modelValue: _unref(moduleState).application.expenses.otherBillPayer.whichBills,
                            "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_unref(moduleState).application.expenses.otherBillPayer.whichBills) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormTextField, {
                            label: "What amount is paid? *",
                            modelValue: _unref(moduleState).application.expenses.otherBillPayer.amount,
                            "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => ((_unref(moduleState).application.expenses.otherBillPayer.amount) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormTextField, {
                            label: "To whom does this person pay the bills? *",
                            modelValue: _unref(moduleState).application.expenses.otherBillPayer.recipientName,
                            "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_unref(moduleState).application.expenses.otherBillPayer.recipientName) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'supportDocGuidance')
                ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                    _hoisted_130,
                    _createVNode(SupportDocPhotoGuidance)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'supportDocUpload')
                ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                    _hoisted_132,
                    _createVNode(ListEditor, {
                      class: "mt-3",
                      headerLabel: "Document Uploads",
                      items: _unref(moduleState).supportDocuments,
                      itemIcon: "fa-paperclip",
                      itemLabel: (item)=>`${item.type} ${item.back ? '(front and back)' : '(front only)'}`,
                      addLabel: "Add Document",
                      onAdd: ()=>supportDocuments.value.add(),
                      onEdit: (idx)=>supportDocuments.value.edit(idx),
                      onRemove: (idx)=>supportDocuments.value.remove(idx)
                    }, null, 8, ["items", "itemLabel", "onAdd", "onEdit", "onRemove"]),
                    (supportDocuments.value.activeItem)
                      ? (_openBlock(), _createBlock(_component_ModalDialog, {
                          key: 0,
                          active: "",
                          title: "Document Upload",
                          severity: "link",
                          firstButtonText: "Cancel",
                          firstButtonSeverity: "danger",
                          onFirstbuttonselected: _cache[82] || (_cache[82] = ($event: any) => (supportDocuments.value.activeItem = null)),
                          secondButtonText: "Save",
                          secondButtonSeverity: "link",
                          onSecondbuttonselected: _cache[83] || (_cache[83] = ($event: any) => (supportDocuments.value.onEditComplete()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([supportDocuments.value.activeItem], (item, idx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: idx /* Defining 'item' alias */,
                                class: "modalScrollContainer"
                              }, [
                                _createVNode(_component_Columns, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_FormTextField, {
                                      label: "What type of document is this? *",
                                      placeholder: "e.g. Birth Record, State ID, Veteran's ID, Driver's License...",
                                      modelValue: item.type,
                                      "onUpdate:modelValue": ($event: any) => ((item.type) = $event),
                                      trimmed: "",
                                      autoFocus: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createElementVNode("div", null, [
                                  _hoisted_133,
                                  _createVNode(_component_DocumentUploadWidget, {
                                    singleDocument: item.front,
                                    onUpload: ($event: any) => (uploadSupportDocument(item as SupportDocument, 'front', $event)),
                                    onDelete: ($event: any) => (item.front = undefined)
                                  }, null, 8, ["singleDocument", "onUpload", "onDelete"])
                                ]),
                                _createElementVNode("div", _hoisted_134, [
                                  _hoisted_135,
                                  _createVNode(_component_DocumentUploadWidget, {
                                    singleDocument: item.back,
                                    onUpload: ($event: any) => (uploadSupportDocument(item as SupportDocument, 'back', $event)),
                                    onDelete: ($event: any) => (item.back = undefined)
                                  }, null, 8, ["singleDocument", "onUpload", "onDelete"])
                                ]),
                                (supportDocuments.value.errors.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supportDocuments.value.errors, (error) => {
                                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_137))
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'equifaxConsent')
                ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                    _hoisted_139,
                    _hoisted_140,
                    _hoisted_141,
                    _hoisted_142,
                    _hoisted_143,
                    _hoisted_144,
                    _hoisted_145,
                    _createVNode(_component_FormRadioGroupField, {
                      class: "mt-3",
                      label: "Do you agree to us verifying your identity? *",
                      options: _unref(EquifaxConsentOptions),
                      modelValue: _unref(moduleState).application.equifaxConsent,
                      "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_unref(moduleState).application.equifaxConsent) = $event))
                    }, null, 8, ["options", "modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (form.value.state.activePage == 'notificationPreferences')
                ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                    _hoisted_147,
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "By Email",
                      modelValue: _unref(moduleState).miscState.notificationPreferences.emailEnabled,
                      "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_unref(moduleState).miscState.notificationPreferences.emailEnabled) = $event)),
                      isDisabled: _unref(moduleState).miscState.notificationPreferences.noneEnabled
                    }, null, 8, ["modelValue", "isDisabled"]),
                    (_unref(moduleState).miscState.notificationPreferences.emailEnabled && !_unref(moduleState).miscState.notificationPreferences.noneEnabled)
                      ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FormTextField, {
                              label: "Email Address",
                              modelValue: _unref(moduleState).notificationPreferences.email,
                              "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_unref(moduleState).notificationPreferences.email) = $event)),
                              trimmed: "",
                              autoFocus: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "By SMS",
                      modelValue: _unref(moduleState).miscState.notificationPreferences.smsEnabled,
                      "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_unref(moduleState).miscState.notificationPreferences.smsEnabled) = $event)),
                      isDisabled: _unref(moduleState).miscState.notificationPreferences.noneEnabled
                    }, null, 8, ["modelValue", "isDisabled"]),
                    (_unref(moduleState).miscState.notificationPreferences.smsEnabled && !_unref(moduleState).miscState.notificationPreferences.noneEnabled)
                      ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_FormTextField, {
                              label: "Phone Number",
                              modelValue: _unref(moduleState).notificationPreferences.sms,
                              "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_unref(moduleState).notificationPreferences.sms) = $event)),
                              trimmed: "",
                              autoFocus: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormCheckboxField, {
                      boxLabel: "Do not contact me",
                      modelValue: _unref(moduleState).miscState.notificationPreferences.noneEnabled,
                      "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_unref(moduleState).miscState.notificationPreferences.noneEnabled) = $event))
                    }, null, 8, ["modelValue"]),
                    (_unref(moduleState).miscState.notificationPreferences.noneEnabled)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_148, _hoisted_150))
                      : _createCommentVNode("", true)
                  ]))
                : (form.value.state.activePage == 'signature')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                      _hoisted_152,
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(SignaturePadField, {
                            style: {"flex-grow":"1.8"},
                            ref_key: "applicantSignaturePad",
                            ref: applicantSignaturePad,
                            label: "Please sign here to complete your application"
                          }, null, 512)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormCheckboxField, {
                        boxLabel: "I have difficulty signing, and require assistance",
                        modelValue: _unref(moduleState).miscState.signature.witnessRequired,
                        "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_unref(moduleState).miscState.signature.witnessRequired) = $event))
                      }, null, 8, ["modelValue"]),
                      (_unref(moduleState).miscState.signature.witnessRequired)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                            _hoisted_154,
                            _hoisted_155,
                            _createVNode(_component_HalfColumn, { class: "mt-3" }, {
                              default: _withCtx(() => [
                                _createVNode(SignaturePadField, {
                                  style: {"flex-grow":"1.8"},
                                  ref_key: "witnessSignaturePad",
                                  ref: witnessSignaturePad,
                                  label: "Witness - please sign your own name below"
                                }, null, 512)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (form.value.state.activePage == 'preSubmit')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                        _hoisted_157,
                        _createElementVNode("div", _hoisted_158, [
                          (submissionInProgress.value)
                            ? (_openBlock(), _createBlock(LoadingSpinner, {
                                key: 0,
                                class: "mt-4"
                              }))
                            : (_openBlock(), _createBlock(_component_SaveButton, {
                                key: 1,
                                large: "",
                                label: "Submit!",
                                icon: "fa-paper-plane",
                                onClick: _cache[91] || (_cache[91] = ($event: any) => (submitApplication()))
                              }))
                        ])
                      ]))
                    : (form.value.state.activePage == 'completed')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                          _hoisted_160,
                          _hoisted_161,
                          _createElementVNode("div", _hoisted_162, [
                            _createVNode(_component_SaveButton, {
                              large: "",
                              label: "Return To Home Page",
                              onClick: _cache[92] || (_cache[92] = ($event: any) => (_ctx.$router.push('/')))
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
              (form.value!.state.errors.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.state.errors, (error) => {
                      return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (!submissionInProgress.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                    (form.value.canNavigateBack())
                      ? (_openBlock(), _createBlock(_component_SaveButton, {
                          key: 0,
                          large: "",
                          label: "Back",
                          icon: "fa-chevron-left",
                          onClick: _cache[93] || (_cache[93] = ($event: any) => (form.value.navigateBack()))
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_165,
                    (form.value.canNavigateForward())
                      ? (_openBlock(), _createBlock(_component_SaveButton, {
                          key: 1,
                          large: "",
                          label: "Next",
                          icon: "fa-chevron-right",
                          iconRight: "",
                          onClick: _cache[94] || (_cache[94] = ($event: any) => (form.value.navigateForward()))
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
    ]),
    _: 1
  }))
}
}

})